"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  AddressAutocomplete: () => AddressAutocomplete,
  COUNTRIES: () => COUNTRIES,
  CountrySelect: () => CountrySelect,
  Icons: () => Icons_exports,
  LoadGoogle: () => AddressAutocomplete2,
  SessionTrackingMap: () => SessionTrackingMap,
  formatCountry: () => formatCountry_default,
  timelineEntryIcon: () => timelineEntryIcon
});
module.exports = __toCommonJS(src_exports);

// src/components/AddressAutocomplete/index.tsx
var import_api = require("@react-google-maps/api");
var React = __toESM(require("react"));
var import_react = require("react");
function AddressAutocomplete({ id, placeholder, onChange, defaultValue }) {
  const [searchBox, setSearchBox] = (0, import_react.useState)();
  function onPlacesChanged() {
    if (searchBox == null) {
      return;
    }
    onChange(searchBox.getPlaces());
  }
  return /* @__PURE__ */ React.createElement(import_api.StandaloneSearchBox, { onLoad: (ref) => setSearchBox(ref), onPlacesChanged: () => onPlacesChanged() }, /* @__PURE__ */ React.createElement(
    "input",
    {
      id,
      type: "text",
      placeholder: placeholder ?? "Search for a location...",
      defaultValue,
      className: "block w-full max-w-lg border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:max-w-xs sm:text-sm"
    }
  ));
}

// src/components/CountrySelect/index.tsx
var import_react2 = __toESM(require("react"));

// src/components/CountrySelect/countries.ts
var COUNTRIES = [
  { name: "Afghanistan", code: "AF" },
  { name: "\xC5land Islands", code: "AX" },
  { name: "Albania", code: "AL" },
  { name: "Algeria", code: "DZ" },
  { name: "American Samoa", code: "AS" },
  { name: "AndorrA", code: "AD" },
  { name: "Angola", code: "AO" },
  { name: "Anguilla", code: "AI" },
  { name: "Antarctica", code: "AQ" },
  { name: "Antigua and Barbuda", code: "AG" },
  { name: "Argentina", code: "AR" },
  { name: "Armenia", code: "AM" },
  { name: "Aruba", code: "AW" },
  { name: "Australia", code: "AU" },
  { name: "Austria", code: "AT" },
  { name: "Azerbaijan", code: "AZ" },
  { name: "Bahamas", code: "BS" },
  { name: "Bahrain", code: "BH" },
  { name: "Bangladesh", code: "BD" },
  { name: "Barbados", code: "BB" },
  { name: "Belarus", code: "BY" },
  { name: "Belgium", code: "BE" },
  { name: "Belize", code: "BZ" },
  { name: "Benin", code: "BJ" },
  { name: "Bermuda", code: "BM" },
  { name: "Bhutan", code: "BT" },
  { name: "Bolivia", code: "BO" },
  { name: "Bosnia and Herzegovina", code: "BA" },
  { name: "Botswana", code: "BW" },
  { name: "Bouvet Island", code: "BV" },
  { name: "Brazil", code: "BR" },
  { name: "British Indian Ocean Territory", code: "IO" },
  { name: "Brunei Darussalam", code: "BN" },
  { name: "Bulgaria", code: "BG" },
  { name: "Burkina Faso", code: "BF" },
  { name: "Burundi", code: "BI" },
  { name: "Cambodia", code: "KH" },
  { name: "Cameroon", code: "CM" },
  { name: "Canada", code: "CA" },
  { name: "Cape Verde", code: "CV" },
  { name: "Cayman Islands", code: "KY" },
  { name: "Central African Republic", code: "CF" },
  { name: "Chad", code: "TD" },
  { name: "Chile", code: "CL" },
  { name: "China", code: "CN" },
  { name: "Christmas Island", code: "CX" },
  { name: "Cocos (Keeling) Islands", code: "CC" },
  { name: "Colombia", code: "CO" },
  { name: "Comoros", code: "KM" },
  { name: "Congo", code: "CG" },
  { name: "Congo, The Democratic Republic of the", code: "CD" },
  { name: "Cook Islands", code: "CK" },
  { name: "Costa Rica", code: "CR" },
  { name: "Cote D'Ivoire", code: "CI" },
  { name: "Croatia", code: "HR" },
  { name: "Cuba", code: "CU" },
  { name: "Cyprus", code: "CY" },
  { name: "Czech Republic", code: "CZ" },
  { name: "Denmark", code: "DK" },
  { name: "Djibouti", code: "DJ" },
  { name: "Dominica", code: "DM" },
  { name: "Dominican Republic", code: "DO" },
  { name: "Ecuador", code: "EC" },
  { name: "Egypt", code: "EG" },
  { name: "El Salvador", code: "SV" },
  { name: "Equatorial Guinea", code: "GQ" },
  { name: "Eritrea", code: "ER" },
  { name: "Estonia", code: "EE" },
  { name: "Ethiopia", code: "ET" },
  { name: "Falkland Islands (Malvinas)", code: "FK" },
  { name: "Faroe Islands", code: "FO" },
  { name: "Fiji", code: "FJ" },
  { name: "Finland", code: "FI" },
  { name: "France", code: "FR" },
  { name: "French Guiana", code: "GF" },
  { name: "French Polynesia", code: "PF" },
  { name: "French Southern Territories", code: "TF" },
  { name: "Gabon", code: "GA" },
  { name: "Gambia", code: "GM" },
  { name: "Georgia", code: "GE" },
  { name: "Germany", code: "DE" },
  { name: "Ghana", code: "GH" },
  { name: "Gibraltar", code: "GI" },
  { name: "Greece", code: "GR" },
  { name: "Greenland", code: "GL" },
  { name: "Grenada", code: "GD" },
  { name: "Guadeloupe", code: "GP" },
  { name: "Guam", code: "GU" },
  { name: "Guatemala", code: "GT" },
  { name: "Guernsey", code: "GG" },
  { name: "Guinea", code: "GN" },
  { name: "Guinea-Bissau", code: "GW" },
  { name: "Guyana", code: "GY" },
  { name: "Haiti", code: "HT" },
  { name: "Heard Island and Mcdonald Islands", code: "HM" },
  { name: "Holy See (Vatican City State)", code: "VA" },
  { name: "Honduras", code: "HN" },
  { name: "Hong Kong", code: "HK" },
  { name: "Hungary", code: "HU" },
  { name: "Iceland", code: "IS" },
  { name: "India", code: "IN" },
  { name: "Indonesia", code: "ID" },
  { name: "Iran, Islamic Republic Of", code: "IR" },
  { name: "Iraq", code: "IQ" },
  { name: "Ireland", code: "IE" },
  { name: "Isle of Man", code: "IM" },
  { name: "Israel", code: "IL" },
  { name: "Italy", code: "IT" },
  { name: "Jamaica", code: "JM" },
  { name: "Japan", code: "JP" },
  { name: "Jersey", code: "JE" },
  { name: "Jordan", code: "JO" },
  { name: "Kazakhstan", code: "KZ" },
  { name: "Kenya", code: "KE" },
  { name: "Kiribati", code: "KI" },
  { name: "Korea, Democratic People'S Republic of", code: "KP" },
  { name: "Korea, Republic of", code: "KR" },
  { name: "Kuwait", code: "KW" },
  { name: "Kyrgyzstan", code: "KG" },
  { name: "Lao People'S Democratic Republic", code: "LA" },
  { name: "Latvia", code: "LV" },
  { name: "Lebanon", code: "LB" },
  { name: "Lesotho", code: "LS" },
  { name: "Liberia", code: "LR" },
  { name: "Libyan Arab Jamahiriya", code: "LY" },
  { name: "Liechtenstein", code: "LI" },
  { name: "Lithuania", code: "LT" },
  { name: "Luxembourg", code: "LU" },
  { name: "Macao", code: "MO" },
  { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
  { name: "Madagascar", code: "MG" },
  { name: "Malawi", code: "MW" },
  { name: "Malaysia", code: "MY" },
  { name: "Maldives", code: "MV" },
  { name: "Mali", code: "ML" },
  { name: "Malta", code: "MT" },
  { name: "Marshall Islands", code: "MH" },
  { name: "Martinique", code: "MQ" },
  { name: "Mauritania", code: "MR" },
  { name: "Mauritius", code: "MU" },
  { name: "Mayotte", code: "YT" },
  { name: "Mexico", code: "MX" },
  { name: "Micronesia, Federated States of", code: "FM" },
  { name: "Moldova, Republic of", code: "MD" },
  { name: "Monaco", code: "MC" },
  { name: "Mongolia", code: "MN" },
  { name: "Montserrat", code: "MS" },
  { name: "Morocco", code: "MA" },
  { name: "Mozambique", code: "MZ" },
  { name: "Myanmar", code: "MM" },
  { name: "Namibia", code: "NA" },
  { name: "Nauru", code: "NR" },
  { name: "Nepal", code: "NP" },
  { name: "Netherlands", code: "NL" },
  { name: "Netherlands Antilles", code: "AN" },
  { name: "New Caledonia", code: "NC" },
  { name: "New Zealand", code: "NZ" },
  { name: "Nicaragua", code: "NI" },
  { name: "Niger", code: "NE" },
  { name: "Nigeria", code: "NG" },
  { name: "Niue", code: "NU" },
  { name: "Norfolk Island", code: "NF" },
  { name: "Northern Mariana Islands", code: "MP" },
  { name: "Norway", code: "NO" },
  { name: "Oman", code: "OM" },
  { name: "Pakistan", code: "PK" },
  { name: "Palau", code: "PW" },
  { name: "Palestinian Territory, Occupied", code: "PS" },
  { name: "Panama", code: "PA" },
  { name: "Papua New Guinea", code: "PG" },
  { name: "Paraguay", code: "PY" },
  { name: "Peru", code: "PE" },
  { name: "Philippines", code: "PH" },
  { name: "Pitcairn", code: "PN" },
  { name: "Poland", code: "PL" },
  { name: "Portugal", code: "PT" },
  { name: "Puerto Rico", code: "PR" },
  { name: "Qatar", code: "QA" },
  { name: "Reunion", code: "RE" },
  { name: "Romania", code: "RO" },
  { name: "Russian Federation", code: "RU" },
  { name: "RWANDA", code: "RW" },
  { name: "Saint Helena", code: "SH" },
  { name: "Saint Kitts and Nevis", code: "KN" },
  { name: "Saint Lucia", code: "LC" },
  { name: "Saint Pierre and Miquelon", code: "PM" },
  { name: "Saint Vincent and the Grenadines", code: "VC" },
  { name: "Samoa", code: "WS" },
  { name: "San Marino", code: "SM" },
  { name: "Sao Tome and Principe", code: "ST" },
  { name: "Saudi Arabia", code: "SA" },
  { name: "Senegal", code: "SN" },
  { name: "Serbia and Montenegro", code: "CS" },
  { name: "Seychelles", code: "SC" },
  { name: "Sierra Leone", code: "SL" },
  { name: "Singapore", code: "SG" },
  { name: "Slovakia", code: "SK" },
  { name: "Slovenia", code: "SI" },
  { name: "Solomon Islands", code: "SB" },
  { name: "Somalia", code: "SO" },
  { name: "South Africa", code: "ZA" },
  { name: "South Georgia and the South Sandwich Islands", code: "GS" },
  { name: "Spain", code: "ES" },
  { name: "Sri Lanka", code: "LK" },
  { name: "Sudan", code: "SD" },
  { name: "Suriname", code: "SR" },
  { name: "Svalbard and Jan Mayen", code: "SJ" },
  { name: "Swaziland", code: "SZ" },
  { name: "Sweden", code: "SE" },
  { name: "Switzerland", code: "CH" },
  { name: "Syrian Arab Republic", code: "SY" },
  { name: "Taiwan, Province of China", code: "TW" },
  { name: "Tajikistan", code: "TJ" },
  { name: "Tanzania, United Republic of", code: "TZ" },
  { name: "Thailand", code: "TH" },
  { name: "Timor-Leste", code: "TL" },
  { name: "Togo", code: "TG" },
  { name: "Tokelau", code: "TK" },
  { name: "Tonga", code: "TO" },
  { name: "Trinidad and Tobago", code: "TT" },
  { name: "Tunisia", code: "TN" },
  { name: "Turkey", code: "TR" },
  { name: "Turkmenistan", code: "TM" },
  { name: "Turks and Caicos Islands", code: "TC" },
  { name: "Tuvalu", code: "TV" },
  { name: "Uganda", code: "UG" },
  { name: "Ukraine", code: "UA" },
  { name: "United Arab Emirates", code: "AE" },
  { name: "United Kingdom", code: "GB" },
  { name: "United States", code: "US" },
  { name: "United States Minor Outlying Islands", code: "UM" },
  { name: "Uruguay", code: "UY" },
  { name: "Uzbekistan", code: "UZ" },
  { name: "Vanuatu", code: "VU" },
  { name: "Venezuela", code: "VE" },
  { name: "Viet Nam", code: "VN" },
  { name: "Virgin Islands, British", code: "VG" },
  { name: "Virgin Islands, U.S.", code: "VI" },
  { name: "Wallis and Futuna", code: "WF" },
  { name: "Western Sahara", code: "EH" },
  { name: "Yemen", code: "YE" },
  { name: "Zambia", code: "ZM" },
  { name: "Zimbabwe", code: "ZW" }
];

// src/components/CountrySelect/index.tsx
var CountrySelect = import_react2.default.forwardRef((props, ref) => {
  (0, import_react2.useEffect)(() => {
    const mutableRef = ref;
    const handleClickOutside = (event) => {
      if (mutableRef.current && !mutableRef.current.contains(event.target) && props.isOpen) {
        props.onToggle();
        setQuery("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
  const [query, setQuery] = (0, import_react2.useState)("");
  return /* @__PURE__ */ import_react2.default.createElement("div", { ref }, /* @__PURE__ */ import_react2.default.createElement("div", { className: "relative mt-1" }, /* @__PURE__ */ import_react2.default.createElement(
    "button",
    {
      type: "button",
      className: "relative w-full py-2 pl-3 pr-10 text-left bg-white border border-gray-300 rounded-md shadow-sm cursor-default focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm",
      onClick: props.onToggle
    },
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "flex items-center truncate" }, /* @__PURE__ */ import_react2.default.createElement(
      "img",
      {
        alt: `${props.selectedValue.code}`,
        src: `https://purecatamphetamine.github.io/country-flag-icons/3x2/${props.selectedValue.code}.svg`,
        className: "inline h-4 mr-2 rounded-sm"
      }
    ), props.selectedValue.name),
    /* @__PURE__ */ import_react2.default.createElement("span", { className: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }, /* @__PURE__ */ import_react2.default.createElement(
      "svg",
      {
        className: "w-5 h-5 text-gray-400",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true"
      },
      /* @__PURE__ */ import_react2.default.createElement(
        "path",
        {
          fillRule: "evenodd",
          d: "M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
          clipRule: "evenodd"
        }
      )
    ))
  ), props.isOpen && /* @__PURE__ */ import_react2.default.createElement("div", { className: "absolute z-10 w-full mt-1 text-base bg-white rounded-md shadow-lg max-h-80 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm" }, /* @__PURE__ */ import_react2.default.createElement("div", { className: "sticky top-0 z-10 bg-white" }, /* @__PURE__ */ import_react2.default.createElement("div", { className: "relative px-3 py-2 text-gray-900 cursor-default select-none" }, /* @__PURE__ */ import_react2.default.createElement(
    "input",
    {
      type: "search",
      name: "search",
      autoComplete: "off",
      className: "block w-full border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 sm:text-sm",
      placeholder: "Search countries",
      onChange: (e) => setQuery(e.target.value)
    }
  )), /* @__PURE__ */ import_react2.default.createElement("hr", null)), /* @__PURE__ */ import_react2.default.createElement("ul", { className: "flex flex-col h-40 overflow-y-scroll" }, COUNTRIES.filter((country) => country.name.toLowerCase().startsWith(query.toLowerCase())).length === 0 ? /* @__PURE__ */ import_react2.default.createElement("li", { className: "relative py-2 pl-3 text-gray-900 cursor-default select-none pr-9" }, "No countries found") : COUNTRIES.filter((country) => country.name.toLowerCase().startsWith(query.toLowerCase())).map((value, index) => {
    return /* @__PURE__ */ import_react2.default.createElement(
      "button",
      {
        key: `${props.id}-${index}`,
        type: "button",
        onClick: () => {
          props.onChange(value.code);
          setQuery("");
          props.onToggle();
        }
      },
      /* @__PURE__ */ import_react2.default.createElement("li", { className: "relative flex items-center py-2 pl-3 text-gray-900 cursor-default select-none pr-9 hover:bg-gray-50" }, /* @__PURE__ */ import_react2.default.createElement(
        "img",
        {
          src: `https://purecatamphetamine.github.io/country-flag-icons/3x2/${value.code}.svg`,
          className: "inline h-4 mr-2 rounded-sm",
          alt: value.code
        }
      ), /* @__PURE__ */ import_react2.default.createElement("span", { className: "font-normal truncate" }, value.name), value.code === props.selectedValue.code ? /* @__PURE__ */ import_react2.default.createElement("span", { className: "absolute inset-y-0 right-0 flex items-center pr-8 text-blue-600" }, /* @__PURE__ */ import_react2.default.createElement(
        "svg",
        {
          className: "w-5 h-5",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 20 20",
          fill: "currentColor",
          "aria-hidden": "true"
        },
        /* @__PURE__ */ import_react2.default.createElement(
          "path",
          {
            fillRule: "evenodd",
            d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
            clipRule: "evenodd"
          }
        )
      )) : null)
    );
  })))));
});

// src/components/Icons/index.tsx
var Icons_exports = {};
__export(Icons_exports, {
  Add: () => Add,
  Anastomosis: () => Anastomosis,
  ArrivalAtDonor: () => ArrivalAtDonor,
  ArriveAtRecipient: () => ArriveAtRecipient,
  ArterialReperfusion: () => ArterialReperfusion,
  Cannulation: () => Cannulation,
  ChevronDown: () => ChevronDown,
  ChevronRight: () => ChevronRight,
  ColdPreservationFlush: () => ColdPreservationFlush,
  CrossclampAtDonor: () => CrossclampAtDonor,
  CrossclampAtRecipient: () => CrossclampAtRecipient,
  Dashboard: () => Dashboard,
  DonorInRoom: () => DonorInRoom,
  Download: () => Download,
  HeadVesselClamp: () => HeadVesselClamp,
  HeartRemovedFromSherpapak: () => HeartRemovedFromSherpapak,
  Help: () => Help,
  HeparinAdministered: () => HeparinAdministered,
  Home: () => Home,
  LeaveDonor: () => LeaveDonor,
  LeaveTxCenter: () => LeaveTxCenter,
  LeftLungAnastomosisComplete: () => LeftLungAnastomosisComplete,
  LeftLungRemovedFromLungguard: () => LeftLungRemovedFromLungguard,
  List: () => List,
  LiverRemovedFromLiverguard: () => LiverRemovedFromLiverguard,
  Logout: () => Logout,
  LungsRemovedFromLungguard: () => LungsRemovedFromLungguard,
  Movie: () => Movie,
  ObservationPeriodStart: () => ObservationPeriodStart,
  OffCardioPulmonaryBypass: () => OffCardioPulmonaryBypass,
  OnCardioPulmonaryBypass: () => OnCardioPulmonaryBypass,
  OrganAccepted: () => OrganAccepted,
  OrganDeclined: () => OrganDeclined,
  OrganRemoval: () => OrganRemoval,
  OrganRemovalLiver: () => OrganRemovalLiver,
  OrganRemovalLung: () => OrganRemovalLung,
  OrganRemovalPancreas: () => OrganRemovalPancreas,
  PancreasPlacedInPancreaspak: () => PancreasPlacedInPancreaspak,
  PancreasRemovedFromPancreaspak: () => PancreasRemovedFromPancreaspak,
  PerfusionStart: () => PerfusionStart,
  PerfusionStop: () => PerfusionStop,
  PlaneArrivalDonor: () => PlaneArrivalDonor,
  PlaneArrivalRecipient: () => PlaneArrivalRecipient,
  PlaneDepartureDonor: () => PlaneDepartureDonor,
  PlaneDepartureRecipient: () => PlaneDepartureRecipient,
  PortalReperfusion: () => PortalReperfusion,
  RightLungAnastomosisComplete: () => RightLungAnastomosisComplete,
  RightLungRemovedFromLungguard: () => RightLungRemovedFromLungguard,
  Search: () => Search,
  Settings: () => Settings,
  StartLogger: () => StartLogger,
  StartSession: () => StartSession,
  StartWean: () => StartWean,
  StopLogger: () => StopLogger,
  StopSession: () => StopSession,
  TimeOfDeath: () => TimeOfDeath,
  TimeOfWithdrawal: () => TimeOfWithdrawal,
  TimeToIncision: () => TimeToIncision,
  WarmIschemicTimeStart: () => WarmIschemicTimeStart
});

// src/components/Icons/Add.tsx
var React3 = __toESM(require("react"));
function Add() {
  return /* @__PURE__ */ React3.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React3.createElement(
    "path",
    {
      d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/Anastomosis.tsx
var React4 = __toESM(require("react"));
function Anastomosis() {
  return /* @__PURE__ */ React4.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React4.createElement(
    "path",
    {
      d: "M13.9999 4C14.4999 4 14.9999 4.1 15.4999 4.4C16.8999 5.2 17.3999 7.1 16.5999 8.5C16.1858 9.19019 11.1986 15.0251 7.49059 19.3634C6.24612 20.8194 5.14575 22.1068 4.41072 22.9746C4.06062 23.3879 3.45853 23.4653 3.01219 23.1584C2.55568 22.8446 2.40951 22.2279 2.675 21.7417C3.09055 20.9807 3.73914 19.7839 4.50219 18.3761C6.02652 15.5635 8.00761 11.9083 9.49992 9.2C10.0999 9.5 10.5999 9.8 11.1999 10.2C10.3999 11.7 9.39992 13.5 8.39992 15.3C11.6999 11.5 14.5999 8 14.8999 7.5C15.0999 7 14.9999 6.4 14.4999 6.1C14.2999 6 14.1999 6 13.9999 6C13.5999 6 13.2999 6.2 13.1999 6.5C13.1499 6.55 13.1249 6.6 13.0999 6.65C13.0749 6.7 13.0499 6.75 12.9999 6.8C13.1999 6.9 13.3999 7 13.4999 7.2L12.3999 8.8C10.3733 7.41824 8.00735 6.37591 5.38009 8.87782C4.985 9.25407 4.36396 9.30883 3.95167 8.95151C3.53802 8.59302 3.49376 7.96134 3.89005 7.58376C6.11332 5.46547 8.57467 4.90422 11.1999 5.9C11.2381 5.82361 11.2763 5.7618 11.3089 5.70902C11.3617 5.62361 11.3999 5.5618 11.3999 5.5C11.8999 4.6 12.8999 4 13.9999 4Z",
      fill: "currentColor",
      style: { fill: "currentColor", fillOpacity: 1 }
    }
  ), /* @__PURE__ */ React4.createElement(
    "path",
    {
      d: "M14.6996 19.9001C15.3996 21.8001 18.0996 23.1001 20.6996 23.1001C20.9081 23.1001 21.0818 23.1001 21.2424 23.0856C21.662 23.0478 21.8996 22.634 21.8996 22.2128C21.8996 21.5256 21.2775 21.0052 20.5912 20.9707C18.6306 20.8723 16.8272 19.9191 16.4996 19.1001C16.2996 18.6001 16.5996 18.2001 17.3996 17.7001C18.5996 17.0001 19.2996 16.0001 19.3996 14.9001C19.4812 13.3508 18.4323 11.8679 17.2833 10.7769C16.8664 10.3811 16.2089 10.4579 15.8464 10.9041C15.4865 11.3471 15.5496 11.9921 15.9587 12.39C16.9129 13.3182 17.4801 14.1563 17.3996 14.8001C17.3996 15.3001 17.0996 15.7001 16.3996 16.1001C14.0996 17.5001 14.3996 19.2001 14.6996 19.9001Z",
      fill: "currentColor",
      style: { fill: "currentColor", fillOpacity: 1 }
    }
  ));
}

// src/components/Icons/ArrivalAtDonor.tsx
var React5 = __toESM(require("react"));
function ArrivalAtDonor() {
  return /* @__PURE__ */ React5.createElement("svg", { width: "18", height: "16", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React5.createElement("path", { d: "m8 0 8 8-8 8-1.41-1.41L12.17 9H0V7h12.17L6.59 1.41 8 0Zm10 0v16h-2V0h2Z", fill: "currentColor", fillRule: "nonzero" }));
}

// src/components/Icons/ArriveAtRecipient.tsx
var React6 = __toESM(require("react"));
function ArriveAtRecipient() {
  return /* @__PURE__ */ React6.createElement("svg", { width: "16", height: "16", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React6.createElement(
    "path",
    {
      d: "M8 1.9c1.16 0 2.1.94 2.1 2.1 0 1.16-.94 2.1-2.1 2.1-1.16 0-2.1-.94-2.1-2.1 0-1.16.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H1.9V13c0-.64 3.13-2.1 6.1-2.1M8 0C5.79 0 4 1.79 4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4Zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/ArterialReperfusion.tsx
var React7 = __toESM(require("react"));
function ArterialReperfusion() {
  return /* @__PURE__ */ React7.createElement("svg", { width: "14", height: "18", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React7.createElement(
    "path",
    {
      d: "M2 17.41.59 16 4 12.59 5.41 14 2 17.41ZM11.5 5H8v5.59L13.41 16 12 17.41l-6-6V5H2.5L7 .5 11.5 5Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/Cannulation.tsx
var React8 = __toESM(require("react"));
function Cannulation() {
  return /* @__PURE__ */ React8.createElement("svg", { width: "20", height: "20", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React8.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.0077 0.292893C14.3983 -0.0976311 15.0314 -0.0976311 15.422 0.292893L19.7077 4.57861C20.0982 4.96913 20.0982 5.6023 19.7077 5.99282C19.3171 6.38335 18.684 6.38335 18.2935 5.99282L17.8584 5.55779L15.9287 7.48751C15.929 7.46774 15.9292 7.44794 15.9292 7.42809C15.9292 7.99104 15.7906 8.52196 15.5457 8.98794L17.5647 11.0069C17.7522 11.1944 17.8575 11.4488 17.8575 11.714C17.8575 11.9792 17.7522 12.2336 17.5647 12.4211L15.3447 14.6411C14.8341 15.1516 14.15 15.4337 13.429 15.4337C12.7079 15.4337 12.0238 15.1516 11.5133 14.6411L10.0007 13.1285L8.35047 14.7787C7.93262 15.1965 7.37338 15.4256 6.78622 15.4256C6.54966 15.4256 6.31762 15.3884 6.09754 15.3167L1.70711 19.7071C1.31658 20.0976 0.683418 20.0976 0.292893 19.7071C-0.0976311 19.3166 -0.0976311 18.6834 0.292893 18.2929L4.68337 13.9024C4.43334 13.1357 4.61287 12.2593 5.22197 11.6502L6.87217 9.99998L5.35901 8.48683C4.84848 7.97629 4.56641 7.29221 4.56641 6.57115C4.56641 5.85008 4.84848 5.16601 5.35901 4.65547L7.57901 2.43547C7.96954 2.04495 8.6027 2.04495 8.99323 2.43547L11.0125 4.45473C11.4785 4.20985 12.009 4.07129 12.572 4.07129C12.5518 4.07129 12.5318 4.07113 12.5117 4.07148L14.4419 2.14129L14.0077 1.70711C13.6172 1.31658 13.6172 0.683417 14.0077 0.292893ZM14.6122 4.76211C14.8434 4.93932 15.0509 5.14593 15.2291 5.37637C15.2267 5.37292 15.2242 5.36953 15.2216 5.36619L16.2665 4.32128L15.6784 3.73321L14.6335 4.77817C14.6264 4.77266 14.6193 4.7673 14.6122 4.76211ZM12.572 10.7856C13.1349 10.7856 13.6655 10.647 14.1315 10.4021L15.4433 11.714L13.9304 13.2269C13.7964 13.3609 13.6216 13.4337 13.429 13.4337C13.2363 13.4337 13.0616 13.3609 12.9275 13.2269L6.77323 7.07261C6.63919 6.93858 6.56641 6.7638 6.56641 6.57115C6.56641 6.3785 6.63919 6.20372 6.77323 6.06968L8.28612 4.55679L9.59827 5.86894C9.3534 6.33492 9.21484 6.86549 9.21484 7.42843C9.21484 9.28253 10.7179 10.7856 12.572 10.7856ZM11.2148 7.42843C11.2148 6.6789 11.8225 6.07129 12.572 6.07129C13.3215 6.07129 13.9291 6.6789 13.9291 7.42843C13.9291 8.17796 13.3215 8.78557 12.572 8.78557C11.8225 8.78557 11.2148 8.17796 11.2148 7.42843ZM8.28622 11.4144L6.63618 13.0644C6.55356 13.147 6.55356 13.2819 6.63618 13.3645C6.67605 13.4043 6.72538 13.4256 6.78622 13.4256C6.84706 13.4256 6.89638 13.4043 6.93625 13.3645L8.58629 11.7144L8.28622 11.4144Z",
      fill: "currentColor",
      style: { fill: "currentColor", fillOpacity: 1 }
    }
  ));
}

// src/components/Icons/ChevronDown.tsx
var React9 = __toESM(require("react"));
function ChevronDown() {
  return /* @__PURE__ */ React9.createElement("svg", { width: "18", height: "18", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React9.createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z" }));
}

// src/components/Icons/ChevronRight.tsx
var React10 = __toESM(require("react"));
function ChevronRight() {
  return /* @__PURE__ */ React10.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React10.createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z" }));
}

// src/components/Icons/ColdPreservationFlush.tsx
var React11 = __toESM(require("react"));
function ColdPreservationFlush() {
  return /* @__PURE__ */ React11.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React11.createElement(
    "path",
    {
      d: "M20.725 18.2001C20.9083 18.4001 20.9958 18.6418 20.9875 18.9251C20.9792 19.2084 20.875 19.4418 20.675 19.6251C20.0417 20.2084 19.3417 20.6834 18.575 21.0501C17.8083 21.4168 16.9917 21.6001 16.125 21.6001C15.2917 21.6001 14.4833 21.4834 13.7 21.2501C12.9167 21.0168 12.15 20.7334 11.4 20.4001C10.8 20.1501 10.1958 19.9168 9.5875 19.7001C8.97917 19.4834 8.35 19.3751 7.7 19.3751C7.11667 19.3751 6.575 19.5251 6.075 19.8251C5.575 20.1251 5.125 20.4918 4.725 20.9251C4.54167 21.1251 4.3125 21.2251 4.0375 21.2251C3.7625 21.2251 3.525 21.1334 3.325 20.9501C3.125 20.7668 3.02083 20.5376 3.0125 20.2626C3.00417 19.9876 3.09167 19.7501 3.275 19.5501C3.85833 18.9168 4.525 18.3959 5.275 17.9876C6.025 17.5793 6.83333 17.3751 7.7 17.3751C8.48333 17.3751 9.24583 17.4876 9.9875 17.7126C10.7292 17.9376 11.4583 18.2084 12.175 18.5251C12.8083 18.8084 13.4458 19.0584 14.0875 19.2751C14.7292 19.4918 15.4 19.6001 16.1 19.6001C16.7167 19.6001 17.2958 19.4668 17.8375 19.2001C18.3792 18.9334 18.875 18.5834 19.325 18.1501C19.525 17.9668 19.7625 17.8793 20.0375 17.8876C20.3125 17.8959 20.5417 18.0001 20.725 18.2001ZM20.725 14.2001C20.9083 14.4001 20.9958 14.6418 20.9875 14.9251C20.9792 15.2084 20.875 15.4418 20.675 15.6251C20.0417 16.2084 19.3417 16.6834 18.575 17.0501C17.8083 17.4168 16.9917 17.6001 16.125 17.6001C15.2917 17.6001 14.4833 17.4834 13.7 17.2501C12.9167 17.0168 12.15 16.7334 11.4 16.4001C10.8 16.1501 10.1958 15.9168 9.5875 15.7001C8.97917 15.4834 8.35 15.3751 7.7 15.3751C7.11667 15.3751 6.575 15.5251 6.075 15.8251C5.575 16.1251 5.125 16.4918 4.725 16.9251C4.54167 17.1251 4.3125 17.2251 4.0375 17.2251C3.7625 17.2251 3.525 17.1334 3.325 16.9501C3.125 16.7668 3.02083 16.5376 3.0125 16.2626C3.00417 15.9876 3.09167 15.7501 3.275 15.5501C3.85833 14.9168 4.525 14.3959 5.275 13.9876C6.025 13.5793 6.83333 13.3751 7.7 13.3751C8.48333 13.3751 9.24167 13.4876 9.975 13.7126C10.7083 13.9376 11.4333 14.2084 12.15 14.5251C12.7833 14.8084 13.425 15.0584 14.075 15.2751C14.725 15.4918 15.4 15.6001 16.1 15.6001C16.7167 15.6001 17.2958 15.4668 17.8375 15.2001C18.3792 14.9334 18.875 14.5834 19.325 14.1501C19.525 13.9668 19.7625 13.8793 20.0375 13.8876C20.3125 13.8959 20.5417 14.0001 20.725 14.2001ZM21 12.0001L3 12.0001C2.71667 12.0001 2.47917 11.9043 2.2875 11.7126C2.09583 11.5209 2 11.2834 2 11.0001C2 10.7168 2.09583 10.4793 2.2875 10.2876C2.47917 10.0959 2.71667 10.0001 3 10.0001L6.15 10.0001L3.625 7.4501C3.44167 7.26676 3.35 7.0376 3.35 6.7626C3.35 6.4876 3.45 6.2501 3.65 6.0501C3.83333 5.86676 4.06667 5.7751 4.35 5.7751C4.63333 5.7751 4.86667 5.86676 5.05 6.0501L9 10.0001L11 10.0001L11 8.0001L7.05 4.0501C6.86667 3.86676 6.775 3.63343 6.775 3.3501C6.775 3.06676 6.86667 2.83343 7.05 2.6501C7.23333 2.46676 7.46667 2.3751 7.75 2.3751C8.03333 2.3751 8.26667 2.46676 8.45 2.6501L11 5.1501L11 2.0001C11 1.71676 11.0958 1.47926 11.2875 1.2876C11.4792 1.09593 11.7167 1.0001 12 1.0001C12.2833 1.0001 12.5208 1.09593 12.7125 1.2876C12.9042 1.47926 13 1.71676 13 2.0001L13 5.1501L15.55 2.6251C15.7333 2.44176 15.9625 2.3501 16.2375 2.3501C16.5125 2.3501 16.75 2.4501 16.95 2.6501C17.1333 2.83343 17.225 3.06676 17.225 3.3501C17.225 3.63343 17.1333 3.86676 16.95 4.0501L13 8.0001L13 10.0001L15 10.0001L18.95 6.0501C19.1333 5.86676 19.3667 5.7751 19.65 5.7751C19.9333 5.7751 20.1667 5.86676 20.35 6.0501C20.5333 6.23343 20.625 6.46676 20.625 6.7501C20.625 7.03343 20.5333 7.26676 20.35 7.4501L17.85 10.0001L21 10.0001C21.2833 10.0001 21.5208 10.0959 21.7125 10.2876C21.9042 10.4793 22 10.7168 22 11.0001C22 11.2834 21.9042 11.5209 21.7125 11.7126C21.5208 11.9043 21.2833 12.0001 21 12.0001Z",
      fill: "black",
      style: { fill: "currentColor", fillOpacity: 1 }
    }
  ));
}

// src/components/Icons/CrossclampAtDonor.tsx
var React12 = __toESM(require("react"));
function CrossclampAtDonor() {
  return /* @__PURE__ */ React12.createElement("svg", { width: "18", height: "20", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React12.createElement(
    "path",
    {
      d: "M6 0h2l-.001 2.837.976 2.97.9755128-2.967L9.9500006 0h2v3.1601272L10.028 9.01l1.5231515 4.63639767C12.2331574 12.93960059 13.1902416 12.5 14.25 12.5c2.0710678 0 3.75 1.67893219 3.75 3.75 0 2.07106781-1.6789322 3.75-3.75 3.75-1.7023425 0-3.1397487-1.13432739-3.5976107-2.68837431l-.0009021.00043684L6 3.1601272V0Zm6.5 16.25c0 .96649831.7835017 1.75 1.75 1.75S16 17.21649831 16 16.25s-.7835017-1.75-1.75-1.75-1.75.78350169-1.75 1.75Zm-12.5 0c0-2.07106781 1.67893219-3.75 3.75-3.75 1.04037881 0 1.98180423.4236698 2.66115844 1.10789158l.45835382-1.39582905 1.05300004 3.202-.4691565 1.42907124C7.1690408 18.63235775 5.6192354 20 3.75 20 1.67893219 20 0 18.32106781 0 16.25Zm2 0c0 .96649831.78350169 1.75 1.75 1.75.81025986 0 1.49190535-.55066362 1.69111321-1.29816764l-.04260095-.01426611.09543693-.29099682C5.4979564 16.34824359 5.5 16.29936045 5.5 16.25c0-.96649831-.78350169-1.75-1.75-1.75S2 15.28350169 2 16.25Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/CrossclampAtRecipient.tsx
var React13 = __toESM(require("react"));
function CrossclampAtRecipient() {
  return /* @__PURE__ */ React13.createElement("svg", { width: "18", height: "20", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React13.createElement(
    "path",
    {
      d: "M6 0h2l-.001 2.837.976 2.97.9755128-2.967L9.9500006 0h2v3.1601272L10.028 9.01l1.5231515 4.63639767C12.2331574 12.93960059 13.1902416 12.5 14.25 12.5c2.0710678 0 3.75 1.67893219 3.75 3.75 0 2.07106781-1.6789322 3.75-3.75 3.75-1.7023425 0-3.1397487-1.13432739-3.5976107-2.68837431l-.0009021.00043684L6 3.1601272V0Zm6.5 16.25c0 .96649831.7835017 1.75 1.75 1.75S16 17.21649831 16 16.25s-.7835017-1.75-1.75-1.75-1.75.78350169-1.75 1.75Zm-12.5 0c0-2.07106781 1.67893219-3.75 3.75-3.75 1.04037881 0 1.98180423.4236698 2.66115844 1.10789158l.45835382-1.39582905 1.05300004 3.202-.4691565 1.42907124C7.1690408 18.63235775 5.6192354 20 3.75 20 1.67893219 20 0 18.32106781 0 16.25Zm2 0c0 .96649831.78350169 1.75 1.75 1.75.81025986 0 1.49190535-.55066362 1.69111321-1.29816764l-.04260095-.01426611.09543693-.29099682C5.4979564 16.34824359 5.5 16.29936045 5.5 16.25c0-.96649831-.78350169-1.75-1.75-1.75S2 15.28350169 2 16.25Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/Dashboard.tsx
var React14 = __toESM(require("react"));
function Dashboard() {
  return /* @__PURE__ */ React14.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React14.createElement(
    "path",
    {
      d: "M3 3v8h8V3H3Zm6 6H5V5h4v4Zm-6 4v8h8v-8H3Zm6 6H5v-4h4v4Zm4-16v8h8V3h-8Zm6 6h-4V5h4v4Zm-6 4v8h8v-8h-8Zm6 6h-4v-4h4v4Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/DonorInRoom.tsx
var React15 = __toESM(require("react"));
function DonorInRoom() {
  return /* @__PURE__ */ React15.createElement("svg", { width: "22", height: "21", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React15.createElement("g", { fill: "currentColor", fillRule: "nonzero" }, /* @__PURE__ */ React15.createElement("path", { d: "M6 15c1.66 0 3-1.34 3-3S7.66 9 6 9s-3 1.34-3 3 1.34 3 3 3Zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1Zm12-3h-8v8H2V6H0v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4Zm2 8h-8v-6h6c1.1 0 2 .9 2 2v4ZM12 0v2h2v2h-2v2h-2V4H8V2h2V0h2Z" })));
}

// src/components/Icons/Download.tsx
var React16 = __toESM(require("react"));
function Download() {
  return /* @__PURE__ */ React16.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React16.createElement("path", { d: "M19 10h-4V4H9v6H5l7 7 7-7ZM5 19v2h14v-2H5Z", fill: "currentColor", fillRule: "nonzero" }));
}

// src/components/Icons/HeadVesselClamp.tsx
var React17 = __toESM(require("react"));
function HeadVesselClamp() {
  return /* @__PURE__ */ React17.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React17.createElement(
    "path",
    {
      d: "M21.5 9C22.0523 9 22.5 9.44772 22.5 10C22.5 10.5127 22.1141 10.9353 21.6169 10.993L21.5 10.9997L18.663 10.999L15.692 11.975L18.66 12.9505L21.5 12.9501L21.6167 12.9569C22.114 13.0146 22.5 13.4372 22.5 13.95C22.5 14.5023 22.0523 14.95 21.5 14.95H18.3399L13.7392 13.4376C12.9277 13.1709 12.0523 13.1709 11.2408 13.4376L7.8536 14.5512C8.5604 15.2332 9 16.1902 9 17.25C9 19.3211 7.32107 21 5.25 21C3.17893 21 1.5 19.3211 1.5 17.25C1.5 15.6158 2.5454 14.2257 4.00395 13.712L18.3399 9H21.5ZM5.25 15.5C4.2835 15.5 3.5 16.2835 3.5 17.25C3.5 18.2165 4.2835 19 5.25 19C6.2165 19 7 18.2165 7 17.25C7 16.2835 6.2165 15.5 5.25 15.5ZM5.25 3C7.32107 3 9 4.67893 9 6.75C9 8.82107 7.32107 10.5 5.25 10.5C3.17893 10.5 1.5 8.82107 1.5 6.75C1.5 4.67893 3.17893 3 5.25 3ZM5.25 5C4.2835 5 3.5 5.7835 3.5 6.75C3.5 7.7165 4.2835 8.5 5.25 8.5C6.2165 8.5 7 7.7165 7 6.75C7 5.7835 6.2165 5 5.25 5Z",
      fill: "currentColor",
      style: { fill: "currentColor", fillOpacity: 1 }
    }
  ));
}

// src/components/Icons/HeartRemovedFromSherpapak.tsx
var React18 = __toESM(require("react"));
function HeartRemovedFromSherpapak() {
  return /* @__PURE__ */ React18.createElement("svg", { width: "20", height: "22", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React18.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React18.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "nonzero",
      d: "m18.1055728 12.5527864 1.7888544.8944272L17.618034 18H2.38196601l-2.2763932-4.5527864 1.78885438-.8944272L3.618 16h12.763z"
    }
  ), /* @__PURE__ */ React18.createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M18 16v6h-2v-4H4v4H2v-6z" }), /* @__PURE__ */ React18.createElement(
    "path",
    {
      d: "M8.9052943 4.78213215c-1.99729059.1678093-2.96477938 1.17423974-2.9024664 3.01929132.06939608 2.0547776 1.91932131 4.39755903 2.92647478 5.48845683 1.00715346 1.0908977 2.83317211.8519391 3.656273-.2200217C13.40867658 11.9978977 14 10.3886144 14 9.15451857c0-1.16211869-.36881989-2.47059335-1.10645968-3.92542398-.23331013-.46015466-.1915799-1.01183939.10829391-1.43166272L13.75 2.74999979l-.25-.25-.58378934.58378934c-.60158776.60158775-1.34174956 1.04617906-2.15541885 1.29469051l-.41216177.12588275c-.46989782.14352168-.95373357.23663413-1.44333574.27776976Z",
      stroke: "currentColor",
      strokeWidth: "2"
    }
  ), /* @__PURE__ */ React18.createElement(
    "path",
    {
      d: "M9.52158363 4.7569595c.66666666.67654755 1.11111111 1.46585302 1.33333333 2.36791642.22222222.9020634.22222222 1.8041268 0 2.7061902",
      stroke: "currentColor",
      strokeWidth: "2"
    }
  ), /* @__PURE__ */ React18.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "nonzero",
      d: "M11.07142857.293453v4.42819411L8.5 5.49999979l-2.75-2.75 1.36124238-1.53752291L9 2.99999979v-2zM12 20v2H8v-2z"
    }
  )));
}

// src/components/Icons/Help.tsx
var React19 = __toESM(require("react"));
function Help() {
  return /* @__PURE__ */ React19.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React19.createElement(
    "path",
    {
      d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm1 17h-2v-2h2v2Zm2.07-7.75-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/HeparinAdministered.tsx
var React20 = __toESM(require("react"));
function HeparinAdministered() {
  return /* @__PURE__ */ React20.createElement("svg", { width: "19", height: "20", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React20.createElement(
    "path",
    {
      d: "M15.2316759.00007507c.2197468.00278166.440276.07481647.6248545.21548915l.1061392.0926346 2.7279787 2.71781228c.2024747.20172008.3059417.46555609.3092763.72826951.0031377.25959067-.0917014.51840377-.2870976.71307184-.1953963.19466806-.4551775.2891537-.7157392.28594887-.2197468-.00270281-.4402761-.07473763-.6248546-.21541031l-.1061391-.0926346-.6295336-.62718745-1.6804622 1.67419956 2.9028492 2.89203098c.2024746.2017201.3059417.4655561.3091972.7282695.0032168.2595907-.0916223.5184038-.2870185.7130719-.1953963.194668-.4551775.2891537-.7157392.2859489-.2957753-.003638-.5929681-.1328825-.8020056-.3860409l-.083929-.1160781-6.8484066 6.8228845c-.4393619.4377244-1.0232292.6512525-1.6094018.6440427-.5238284-.0064429-1.04975198-.1889928-1.47798971-.5461283l-.15581524-.1421065-1.08419667-1.0801561L.39409824 20 0 17.4657548l3.63473076-3.6211851-1.08419667-1.0801562c-.45253936-.4508529-.68353387-1.0406054-.69080926-1.6277162-.00643262-.5191005.16219724-1.0363864.50832781-1.452358l.13812408-.151046L9.3545833 2.71040887c-.3309795-.20725005-.499824-.54586383-.5039972-.88263294-.0032168-.25959067.0916223-.51840377.2870185-.71307184.1953963-.19466806.4551775-.2891537.7157393-.28594887.2197467.00270281.440276.07473762.6248545.21541031l.1061392.0926346 2.9028491 2.89203101 1.6804622-1.67419956-.6295335-.62718745c-.2024747-.20172007-.3059417-.46555608-.3091972-.7282695-.0032169-.25959067.0916222-.51840378.2870185-.71307184.1953962-.19466807.4551775-.2891537.7157392-.28602772Zm-4.4281105 4.19362648L3.8002179 11.1709495l3.9870458 3.9721871 1.6804622-1.6741995-1.7661913-1.7596093-.0752603-.0881059c-.0894067-.1235953-.1350463-.2697436-.1368497-.4152812-.0022155-.1787864.0618826-.3574141.1954759-.4905095.1335933-.1330954.3128891-.1969547.4923444-.1947475.146082.0017968.292777.0472663.4168346.1363398l.0884355.0749797 1.7661914 1.7596093 1.6804621-1.6741996-1.7661913-1.7596092-.0752602-.0881059c-.0894067-.1235954-.1350463-.2697437-.1368498-.4152812-.0022155-.1787865.0618827-.3574141.195476-.4905096.1335933-.13309539.3128891-.1969547.4923443-.19474746.146082.00179676.292777.04726628.4168347.13633976l.0884355.0749798 1.7661913 1.7596092 1.6804622-1.6741996-3.9870458-3.97218715Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/Home.tsx
var React21 = __toESM(require("react"));
function Home() {
  return /* @__PURE__ */ React21.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React21.createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M10 21v-6h4v6h5v-8h3L12 4 2 13h3v8z" }));
}

// src/components/Icons/LeaveDonor.tsx
var React22 = __toESM(require("react"));
function LeaveDonor() {
  return /* @__PURE__ */ React22.createElement("svg", { width: "18", height: "16", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React22.createElement("path", { d: "M2 16H0V0h2v7h12.17L8.59 1.41 10 0l8 8-8 8-1.41-1.41L14.17 9H2v7Z", fill: "currentColor", fillRule: "nonzero" }));
}

// src/components/Icons/LeaveTxCenter.tsx
var React23 = __toESM(require("react"));
function LeaveTxCenter() {
  return /* @__PURE__ */ React23.createElement("svg", { width: "18", height: "16", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React23.createElement("path", { d: "M2 16H0V0h2v7h12.17L8.59 1.41 10 0l8 8-8 8-1.41-1.41L14.17 9H2v7Z", fill: "currentColor", fillRule: "nonzero" }));
}

// src/components/Icons/LeftLungAnastomosisComplete.tsx
var React24 = __toESM(require("react"));
function LeftLungAnastomosisComplete() {
  return /* @__PURE__ */ React24.createElement("svg", { width: "24", height: "22", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React24.createElement(
    "path",
    {
      d: "m2.6778831 7.34868613-.1408278.21194616C.7552497 10.3001787 2e-7 13.8802015 2e-7 17.5906238c0 3.061815 1.5263547 4.230764 4.3946412 3.8231386l1.1427057-.185628.5719491-.1016883c2.0961445-.3988215 3.1111656-.9222343 3.9642318-2.2914079.5783041-.9281798.8161638-1.7317909.8928391-3.1071494l.0198345-.4805838c.0023927-.083945.0043495-.1698935.0059009-.2579648l.0046915-.5548569-.0035596-.6115362-.014577-1.1618047.0068605-1.7846479c-.0001424-.1088398-.0006087-.215383-.0014285-.3197275l-.0093984-.6004642c-.0065648-.2677224-.0163443-.5198467-.0299828-.758498l-4.801972 4.0655815-1.2918844-1.5267726 5.7204633-4.84080604c-.1789802-.55506003-.4292511-1.05203056-.7749375-1.57047981-1.6924719-2.53831366-4.8465341-1.32359326-7.1184945 2.02335828ZM10.996794 0v7.46379895l2.0551194 1.73703175c-.0135485.2377563-.0232731.4888809-.0298101.7554721l-.0093985.6004642c-.0008198.1043445-.0012861.2108877-.0014285.3197275l.0068605 1.7846479-.0145769 1.1618047-.0035597.6115362.0046915.5548569c.0015515.0880713.0035082.1740198.0059009.2579648l.0198346.4805838c.0766752 1.3753585.3145349 2.1789696.892839 3.1071494.85306616 1.3691736 1.86808734 1.8925864 3.96423176 2.2914079l.57194919.1016883 1.14270566.185628c2.86828647.4076254 4.39464119-.7613236 4.39464119-3.8231386 0-3.7104223-.75524952-7.2904451-2.53705511-10.02999151l-.14082777-.21194616c-2.27196044-3.34695154-5.42602266-4.56167194-7.11849447-2.02335828-.34589495.51876195-.59625925 1.01601925-.77526135 1.57148421L12.996794 6.536V0h-2Zm4.86764375 6.43484746c.6380768-.95696663 2.29146333-.2856934 3.9187217 2.21623491C21.31685519 11.0091571 21.996794 14.2321931 21.996794 17.5906238c0 1.8216681-.42688358 2.1266374-2.29468867 1.814964l-.60734702-.099799-.79064671-.1356313-.43021983-.085947c-1.28089398-.2757258-1.81108251-.5972806-2.25314435-1.3067911-.31056375-.4984557-.47773664-.981668-.55789178-1.7530926l-.02918894-.3491409c-.00403167-.0614259-.00766047-.1245436-.01090692-.1894635l-.01505507-.4120308c-.00179929-.0725712-.00325733-.1471658-.00439467-.2238944l-.00313995-.4868643.0035708-.5433887.00716716-.5053468.0080054-.9189669L15.013794 10.861l2.83705776 2.4023863 1.29188448-1.5267726-3.99436455-3.38205825c.12307378-.80009725.34337226-1.36075405.71606606-1.91970799Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/LeftLungRemovedFromLungguard.tsx
var React25 = __toESM(require("react"));
function LeftLungRemovedFromLungguard() {
  return /* @__PURE__ */ React25.createElement("svg", { width: "24", height: "22", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React25.createElement(
    "path",
    {
      d: "m1.8944272 12.5527864-1.7888544.8944272L2.0004272 17.235 2 22h2v-4h16v4h2l.00042719-4.765 1.894-3.7877864-1.78885438-.8944272L20.382 16H3.619l-1.7245728-3.4472136ZM10 20v2h4v-2h-4Zm1-20 .0004272 3.736-.0364367-.07515474c-.0836407-.16240394-.1797395-.3233746-.2899639-.48810958-1.2640993-1.88924887-3.5345051-1.03223424-5.1028562 1.23879617l-.1223275.1822053c-1.1796096 1.8073438-1.6741648 4.14345924-1.6741648 6.56129255 0 2.163055 1.1595722 3.0583529 3.1623183 2.7932771l.7844221-.1256134c1.6794354-.2794813 2.4733956-.6253481 3.1351256-1.683726.5219523-.8348161.6446991-1.5068287.6434464-3.0177l-.0114415-1.06594113.0036727-1.31180012c-.0005486-.09284647-.001511-.18312849-.0029366-.27099998L11.481 6.18355996 8.5082641 8.69132585 7.2190086 7.16233269 11.0004272 3.973 11 4.90386914 12.5244272 6.188l-.0090342.28452617c-.0007128.04393575-.0013098.08847412-.0017972.13363437l-.0011394.13736561.0036727 1.31180012-.0114416 1.06594113c-.0012527 1.5108713.1214941 2.1828839.6434465 3.0177.66173 1.0583779 1.45569018 1.4042447 3.13512561 1.683726l.7844221.1256134C19.0704278 14.2133826 20.23 13.3180847 20.23 11.1550297c0-2.41783331-.49455527-4.75394875-1.67416484-6.56129255l-.1223275-.1822053c-1.56835112-2.27103041-3.8387569-3.12804504-5.10285616-1.23879617-.1281765.19156502-.2372514.37803969-.3298468.56759726L13 0h-2Zm3.99288171 4.28493647c.09266982-.13849889.15486681-.1540668.39543638-.05673612.44197511.17881621.99259172.69244876 1.4926806 1.45866205C17.8112536 7.11215639 18.23 9.0901758 18.23 11.1550297l-.0004787.1245344-.00551579.215191c-.02258388.4514366-.12540415.5575843-.56550675.5166989l-.21001475-.0259463-1.04466799-.1713803-.36239699-.0701853c-.7132056-.1523912-.97900612-.3158496-1.197464-.6652535-.20075153-.3210841-.29291394-.6456005-.32505147-1.2781766l-.01129153-.3433699-.00263639-.4031751.01019503-.87891322L14.51542719 7.867l.97630867.82432585 1.28925556-1.52899316-2.18012426-1.83850948c.07164948-.43722272.19390842-.74280891.39201455-1.03888674Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/List.tsx
var React26 = __toESM(require("react"));
function List() {
  return /* @__PURE__ */ React26.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React26.createElement(
    "path",
    {
      d: "M3 13h2v-2H3v2Zm0 4h2v-2H3v2Zm0-8h2V7H3v2Zm4 4h14v-2H7v2Zm0 4h14v-2H7v2ZM7 7v2h14V7H7Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/LiverRemovedFromLiverguard.tsx
var React27 = __toESM(require("react"));
function LiverRemovedFromLiverguard() {
  return /* @__PURE__ */ React27.createElement("svg", { width: "24", height: "21", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React27.createElement(
    "path",
    {
      d: "m22.1055728 11.5527864 1.7888544.8944272L21.9995728 16.235 22 21h-2v-4H4v4H2l-.00042719-4.765-1.894-3.7877864 1.78885438-.8944272L3.618 15h16.763l1.7245728-3.4472136ZM14 19v2h-4v-2h4Zm3.40669-19C18.9121209 0 20 1.14262809 20 2.61998243c0 1.27398873-1.2676016 2.68770144-3.2880632 4.19283122-1.0810204.80529922-2.3440282 1.32432025-3.7755256 1.55764745-.3062828.3708004-.6546953.7188012-1.0409951 1.0490035l-.1575987.1325484-.3077504.2449587c-.1033446.0790682-.2090609.156812-.321981.2370122l-.1753869.1226153-.397687.2676271-.229548.1506831-.81729894.5450856c-.52654283.340147-.9314153.5553821-1.37633617.7060841-.67855826.2298389-1.33834913.2449567-1.963046-.025205-1.25322476-.5419802-1.57894713-1.2935409-1.71402955-3.0790368l-.05864165-.8112993-.02879183-.20196269-.17613811-1.00849211-.07227056-.45026463c-.05108306-.34833223-.08010259-.63964233-.09300252-.95041973-.06000479-1.44560011.33471132-2.6311592 1.39155174-3.52962212C6.77808491.59605188 9.24906657.04031777 12.858364.00211957L13.2640839 0H17.40669Zm-4.9842284 2.20042352L12.399 2.011l-.22182.00619921c-2.78105212.09131932-4.62167344.54299803-5.48429829 1.27635043-.48766601.41458466-.69303838.95065454-.69295139 1.72443799l.00425772.19846549.00769376.14361273.02668783.29743151.04366114.33120828.0629219.38918747.14699639.83187376.05900715.37225057.03006003.2743.04625656.69981056.0274361.3456169.03053241.2787504c.07142461.5378231.18334042.6662447.45721974.7846889.12229244.0528876.28374392.0491882.52754241-.0333903.2604989-.0882353.54909952-.2432423.95794083-.5081906l1.17741731-.7833122.32270581-.2218854c.09866519-.06984.18986829-.1366662.27793319-.2038023l.1302841-.1013523.2594184-.21407125c.732078-.62576765 1.2610455-1.30530345 1.5649895-2.0883803.3100418-.79878745.414059-1.88790188.2957795-3.26114853l-.0342105-.3492275Zm1.9902005-.19905989c.16721 1.5422164.1068564 2.85592438-.193726 3.94594555.4679513-.196073.900377-.44202612 1.2981974-.7383799.4736656-.3528541.8972722-.70569107 1.2547218-1.03475554l.2898082-.27567936.1320488-.13243444.2369791-.25198065C17.7945861 3.10981694 18 2.78869876 18 2.61998243c0-.35473702-.1741577-.57313317-.4847703-.61326503L17.40669 2l-2.9940279.00136363Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/Logout.tsx
var React28 = __toESM(require("react"));
function Logout() {
  return /* @__PURE__ */ React28.createElement("svg", { height: "24", width: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React28.createElement(
    "path",
    {
      d: "M13 3h-2v10h2V3zm4.83 2.17-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z",
      fill: "currentColor"
    }
  ));
}

// src/components/Icons/LungsRemovedFromLungguard.tsx
var React29 = __toESM(require("react"));
function LungsRemovedFromLungguard() {
  return /* @__PURE__ */ React29.createElement("svg", { width: "24", height: "22", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React29.createElement("g", { stroke: "currentColor", strokeWidth: "2", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React29.createElement("g", { strokeLinejoin: "round" }, /* @__PURE__ */ React29.createElement(
    "path",
    {
      d: "M19.227272 11.1550297c0 1.6785995-.76652321 2.015042-2.2013594 1.7764507-1.4348362-.2385913-2.4108641-.3282478-3.0325961-1.3226524-.6217319-.9944046-.4792412-2.19544451-.4792412-3.74843792 0-1.5529934-.1150345-2.99570581.6449633-4.131554.7599977-1.1358482 2.325393-.47501245 3.5566503 1.41146369 1.23125737 1.88647614 1.5115831 4.33613051 1.5115831 6.01472993ZM4.77 11.1550297c0 1.6785995.76652321 2.015042 2.2013594 1.7764507 1.43483619-.2385913 2.41086413-.3282478 3.03259608-1.3226524.62173195-.9944046.47924123-2.19544451.47924123-3.74843792 0-1.5529934.11503446-2.99570581-.64496329-4.131554-.75999776-1.1358482-2.325393-.47501245-3.55665034 1.41146369C5.05032573 7.02677591 4.77 9.47643028 4.77 11.1550297Z",
      strokeLinecap: "round"
    }
  ), /* @__PURE__ */ React29.createElement("path", { d: "M12 0v4.43902439M12 4.43902439 7.86363636 7.92682927M12.0000004 4.43902439l4.1363636 3.48780488" })), /* @__PURE__ */ React29.createElement("path", { d: "m1 13 2 4h18l2-4M21 22v-5H3v5M10 21h4" })));
}

// src/components/Icons/Movie.tsx
var React30 = __toESM(require("react"));
function Movie() {
  return /* @__PURE__ */ React30.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React30.createElement(
    "path",
    {
      d: "M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2ZM8 17H6v-2h2v2Zm0-4H6v-2h2v2Zm0-4H6V7h2v2Zm10 8h-2v-2h2v2Zm0-4h-2v-2h2v2Zm0-4h-2V7h2v2Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/ObservationPeriodStart.tsx
var React31 = __toESM(require("react"));
function ObservationPeriodStart() {
  return /* @__PURE__ */ React31.createElement("svg", { width: "22", height: "15", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React31.createElement(
    "path",
    {
      d: "M11 2c3.79 0 7.17 2.13 8.82 5.5C18.17 10.87 14.79 13 11 13s-7.17-2.13-8.82-5.5C3.83 4.13 7.21 2 11 2m0-2C6 0 1.73 3.11 0 7.5 1.73 11.89 6 15 11 15s9.27-3.11 11-7.5C20.27 3.11 16 0 11 0Zm0 5c1.38 0 2.5 1.12 2.5 2.5S12.38 10 11 10 8.5 8.88 8.5 7.5 9.62 5 11 5m0-2C8.52 3 6.5 5.02 6.5 7.5S8.52 12 11 12s4.5-2.02 4.5-4.5S13.48 3 11 3Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/OffCardioPulmonaryBypass.tsx
var React32 = __toESM(require("react"));
function OffCardioPulmonaryBypass() {
  return /* @__PURE__ */ React32.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React32.createElement(
    "path",
    {
      d: "M14.6423 4.44895C13.2197 3.95115 11.6854 3.86535 10.2161 4.20143C8.74689 4.5375 7.40247 5.28179 6.33775 6.34855C5.27302 7.41532 4.5313 8.76115 4.19803 10.231C3.86476 11.7009 3.95349 13.235 4.45401 14.6567C4.95453 16.0783 5.84647 17.3297 7.02708 18.2666C8.2077 19.2035 9.62896 19.7878 11.1271 19.9522C11.6761 20.0125 12.0723 20.5064 12.0121 21.0554C11.9518 21.6044 11.4579 22.0006 10.9089 21.9403C9.0362 21.7347 7.25962 21.0043 5.78385 19.8332C4.30808 18.6621 3.19316 17.0979 2.56751 15.3209C1.94187 13.5438 1.83095 11.6261 2.24754 9.78879C2.66413 7.95144 3.59128 6.26914 4.92218 4.93569C6.25309 3.60224 7.93361 2.67188 9.77016 2.25178C11.6067 1.83168 13.5246 1.93893 15.3028 2.56118C17.0811 3.18343 18.6474 4.29537 19.8213 5.76889C20.9953 7.24242 21.7291 9.0176 21.9382 10.8899C21.9995 11.4388 21.6043 11.9335 21.0554 11.9948C20.5065 12.0561 20.0119 11.6608 19.9506 11.112C19.7833 9.61408 19.1962 8.19394 18.2571 7.01512C17.3179 5.83629 16.0649 4.94675 14.6423 4.44895Z",
      fill: "currentColor",
      style: { fill: "currentColor", fillOpacity: 1 }
    }
  ), /* @__PURE__ */ React32.createElement(
    "path",
    {
      d: "M12.0228 17.5C11.8538 17.5 11.7121 17.44 11.5978 17.3201C11.4834 17.2001 11.4263 17.0514 11.4263 16.8741V13.5569C11.1479 13.9533 10.8323 14.3288 10.4793 14.6835C10.1264 15.0382 9.72624 15.3772 9.27886 15.7006C9.11979 15.8153 8.9483 15.8675 8.76438 15.857C8.58045 15.8466 8.4189 15.7684 8.27972 15.6223C8.17036 15.5076 8.13308 15.3642 8.16787 15.192C8.20267 15.0199 8.29463 14.8817 8.44375 14.7774C9.07008 14.3393 9.72375 13.716 10.4048 12.9075C11.0858 12.0991 11.4263 11.1264 11.4263 9.98933V8.62802L10.8894 9.17568C10.7801 9.29042 10.6409 9.3478 10.4719 9.3478C10.3029 9.3478 10.1637 9.29042 10.0543 9.17568C9.93501 9.0505 9.87785 8.90185 9.88282 8.72973C9.88779 8.55761 9.94495 8.41418 10.0543 8.29943L11.6052 6.67212C11.6649 6.60953 11.7295 6.5652 11.7991 6.53912C11.8687 6.51304 11.9432 6.5 12.0228 6.5C12.1023 6.5 12.1769 6.51304 12.2465 6.53912C12.3161 6.5652 12.3807 6.60953 12.4403 6.67212L13.9912 8.29943C14.1006 8.41418 14.1553 8.56022 14.1553 8.73755C14.1553 8.91489 14.1006 9.06093 13.9912 9.17568C13.8719 9.30085 13.7303 9.36344 13.5662 9.36344C13.4022 9.36344 13.2655 9.30607 13.1561 9.19132L12.6193 8.62802V16.8741C12.6193 17.0514 12.5621 17.2001 12.4478 17.3201C12.3335 17.44 12.1918 17.5 12.0228 17.5Z",
      fill: "currentColor",
      style: { fill: "currentColor", fillOpacity: 1 }
    }
  ), /* @__PURE__ */ React32.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.4625 21.5375C15.4375 22.5125 16.6167 23 18 23C19.3833 23 20.5625 22.5125 21.5375 21.5375C22.5125 20.5625 23 19.3833 23 18C23 16.6167 22.5125 15.4375 21.5375 14.4625C20.5625 13.4875 19.3833 13 18 13C16.6167 13 15.4375 13.4875 14.4625 14.4625C13.4875 15.4375 13 16.6167 13 18C13 19.3833 13.4875 20.5625 14.4625 21.5375ZM18.9 16.15C19 16.05 19.1167 16 19.25 16C19.3833 16 19.5 16.05 19.6 16.15C19.7 16.25 19.75 16.3667 19.75 16.5V19.5C19.75 19.6333 19.7 19.75 19.6 19.85C19.5 19.95 19.3833 20 19.25 20C19.1167 20 19 19.95 18.9 19.85C18.8 19.75 18.75 19.6333 18.75 19.5V16.5C18.75 16.3667 18.8 16.25 18.9 16.15ZM16.4 16.15C16.5 16.05 16.6167 16 16.75 16C16.8833 16 17 16.05 17.1 16.15C17.2 16.25 17.25 16.3667 17.25 16.5V19.5C17.25 19.6333 17.2 19.75 17.1 19.85C17 19.95 16.8833 20 16.75 20C16.6167 20 16.5 19.95 16.4 19.85C16.3 19.75 16.25 19.6333 16.25 19.5V16.5C16.25 16.3667 16.3 16.25 16.4 16.15Z",
      fill: "currentColor",
      style: { fill: "currentColor", fillOpacity: 1 }
    }
  ));
}

// src/components/Icons/OnCardioPulmonaryBypass.tsx
var React33 = __toESM(require("react"));
function OnCardioPulmonaryBypass() {
  return /* @__PURE__ */ React33.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React33.createElement(
    "path",
    {
      d: "M14.6423 4.44895C13.2197 3.95115 11.6854 3.86535 10.2161 4.20143C8.74689 4.5375 7.40247 5.28179 6.33775 6.34855C5.27302 7.41532 4.5313 8.76115 4.19803 10.231C3.86476 11.7009 3.95349 13.235 4.45401 14.6567C4.95453 16.0783 5.84647 17.3297 7.02708 18.2666C8.2077 19.2035 9.62896 19.7878 11.1271 19.9522C11.6761 20.0125 12.0723 20.5064 12.0121 21.0554C11.9518 21.6044 11.4579 22.0006 10.9089 21.9403C9.0362 21.7347 7.25962 21.0043 5.78385 19.8332C4.30808 18.6621 3.19316 17.0979 2.56751 15.3209C1.94187 13.5438 1.83095 11.6261 2.24754 9.78879C2.66413 7.95144 3.59128 6.26914 4.92218 4.93569C6.25309 3.60224 7.93361 2.67188 9.77016 2.25178C11.6067 1.83168 13.5246 1.93893 15.3028 2.56118C17.0811 3.18343 18.6474 4.29537 19.8213 5.76889C20.9953 7.24242 21.7291 9.0176 21.9382 10.8899C21.9995 11.4388 21.6043 11.9335 21.0554 11.9948C20.5065 12.0561 20.0119 11.6608 19.9506 11.112C19.7833 9.61408 19.1962 8.19394 18.2571 7.01512C17.3179 5.83629 16.0649 4.94675 14.6423 4.44895Z",
      fill: "currentColor",
      style: { fill: "currentColor", fillOpacity: 1 }
    }
  ), /* @__PURE__ */ React33.createElement(
    "path",
    {
      d: "M12.0228 17.5C11.8538 17.5 11.7121 17.44 11.5978 17.3201C11.4834 17.2001 11.4263 17.0514 11.4263 16.8741V13.5569C11.1479 13.9533 10.8323 14.3288 10.4793 14.6835C10.1264 15.0382 9.72624 15.3772 9.27886 15.7006C9.11979 15.8153 8.9483 15.8675 8.76438 15.857C8.58045 15.8466 8.4189 15.7684 8.27972 15.6223C8.17036 15.5076 8.13308 15.3642 8.16787 15.192C8.20267 15.0199 8.29463 14.8817 8.44375 14.7774C9.07008 14.3393 9.72375 13.716 10.4048 12.9075C11.0858 12.0991 11.4263 11.1264 11.4263 9.98933V8.62802L10.8894 9.17568C10.7801 9.29042 10.6409 9.3478 10.4719 9.3478C10.3029 9.3478 10.1637 9.29042 10.0543 9.17568C9.93501 9.0505 9.87785 8.90185 9.88282 8.72973C9.88779 8.55761 9.94495 8.41418 10.0543 8.29943L11.6052 6.67212C11.6649 6.60953 11.7295 6.5652 11.7991 6.53912C11.8687 6.51304 11.9432 6.5 12.0228 6.5C12.1023 6.5 12.1769 6.51304 12.2465 6.53912C12.3161 6.5652 12.3807 6.60953 12.4403 6.67212L13.9912 8.29943C14.1006 8.41418 14.1553 8.56022 14.1553 8.73755C14.1553 8.91489 14.1006 9.06093 13.9912 9.17568C13.8719 9.30085 13.7303 9.36344 13.5662 9.36344C13.4022 9.36344 13.2655 9.30607 13.1561 9.19132L12.6193 8.62802V16.8741C12.6193 17.0514 12.5621 17.2001 12.4478 17.3201C12.3335 17.44 12.1918 17.5 12.0228 17.5Z",
      fill: "currentColor",
      style: { fill: "currentColor", fillOpacity: 1 }
    }
  ), /* @__PURE__ */ React33.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.4625 21.5375C15.4375 22.5125 16.6167 23 18 23C19.3833 23 20.5625 22.5125 21.5375 21.5375C22.5125 20.5625 23 19.3833 23 18C23 16.6167 22.5125 15.4375 21.5375 14.4625C20.5625 13.4875 19.3833 13 18 13C16.6167 13 15.4375 13.4875 14.4625 14.4625C13.4875 15.4375 13 16.6167 13 18C13 19.3833 13.4875 20.5625 14.4625 21.5375ZM20.075 18.425L17.525 20.025C17.3583 20.125 17.1875 20.1292 17.0125 20.0375C16.8375 19.9458 16.75 19.8 16.75 19.6V16.4C16.75 16.2 16.8375 16.0542 17.0125 15.9625C17.1875 15.8708 17.3583 15.875 17.525 15.975L20.075 17.575C20.2417 17.675 20.325 17.8167 20.325 18C20.325 18.1833 20.2417 18.325 20.075 18.425Z",
      fill: "currentColor",
      style: { fill: "currentColor", fillOpacity: 1 }
    }
  ));
}

// src/components/Icons/OrganAccepted.tsx
var React34 = __toESM(require("react"));
function OrganAccepted() {
  return /* @__PURE__ */ React34.createElement("svg", { width: "20", height: "20", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React34.createElement(
    "path",
    {
      d: "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm4.59-12.42L8 12.17 5.41 9.59 4 11l4 4 8-8-1.41-1.42Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/OrganDeclined.tsx
var React35 = __toESM(require("react"));
function OrganDeclined() {
  return /* @__PURE__ */ React35.createElement("svg", { width: "20", height: "20", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React35.createElement(
    "path",
    {
      d: "M10 0c5.52 0 10 4.48 10 10s-4.48 10-10 10S0 15.52 0 10 4.48 0 10 0ZM3.68258243 5.09798489C2.62849561 6.45316423 2 8.1548041 2 10c0 4.41 3.59 8 8 8 1.8451959 0 3.5468358-.6284956 4.9020151-1.6825824L3.68258243 5.09798489ZM10 2c-1.8451959 0-3.54683577.62849561-4.90201511 1.68258243L16.3174176 14.9020151C17.3715044 13.5468358 18 11.8451959 18 10c0-4.41-3.59-8-8-8Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/OrganRemoval.tsx
var React36 = __toESM(require("react"));
function OrganRemoval() {
  return /* @__PURE__ */ React36.createElement("svg", { width: "20", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React36.createElement(
    "path",
    {
      d: "M20 22v2H0v-2h20ZM12 .11257411l.0006285 5.32225163c.2443846-.18248305.4730112-.38653333.6829551-.61015592l.2036081-.2300728 2.3662228-2.83769581 3.0530368 3.05113197-2.2646504 3.1685324c-.3147967.44044037-.3068471 1.03435892.0196184 1.46621427C17.3473196 11.1437452 18 13.0009071 18 14.9863195c0 1.5467306-.5167614 3.382032-1.3516592 5.0143699l-2.3024577.0002237C15.3368089 18.452804 16 16.4871078 16 14.9863195c0-1.4369669-.4397738-2.7841141-1.3351504-4.0641716l-.1988457-.2732795-.1218445-.1725223c-.6935579-1.05297094-.7117998-2.41586684-.0466666-3.48701683l.1171844-.17572048L15.693 5.024l-.306-.306-.9637588 1.15743738c-.7939641.95216246-1.8184411 1.68260768-2.9735678 2.1232123l-.2914457.10407338-.1333794.04377454c.8240046.95883415 1.414003 2.0262272 1.7629655 3.1975954.4666138 1.5662905.4977214 3.1431535.0933228 4.7108536l-.0933228.3357884-1.9167516-.5710198c.3889455-1.3055797.3889455-2.5990227 0-3.9046025-.3591774-1.205657-1.0545605-2.27531288-2.1029133-3.21989874l-.0141593-.01019679-.3201273.03976639-.3212645.03129745-.26364111.02528763c-2.7622435.29891907-3.93031841 1.53408956-3.8446458 3.93142596.07632547 2.1357797 1.63539695 4.8220035 3.7945854 7.2875785l-2.59746012-.0005685c-1.85762463-2.3994339-3.11378937-4.9193351-3.1958494-7.2155824-.08540464-2.3898381.8141414-4.11419476 2.58925802-5.10048189L1.52930466 5.05648178l3.40932882-3.40932882L7 3.364V1.77924078l5-1.66666667ZM5.061 4.353l-.59.59 2.30664837 1.97913312c.0729308-.01413599.14665107-.02755207.22115765-.04024613l.00049864-.91431288L5.061 4.353ZM10 2.887 9 3.22l.0003239 3.39852593a10.18892567 10.18892567 0 0 0 .8791832-.20846438l.1197976-.03748744L10 2.887Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/OrganRemovalLiver.tsx
var React37 = __toESM(require("react"));
function OrganRemovalLiver() {
  return /* @__PURE__ */ React37.createElement("svg", { width: "25", height: "18", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React37.createElement(
    "path",
    {
      d: "M20.5 0C22.5463901 0 24 1.55908744 24 3.5956633c0 1.76254625-1.9098549 3.9376355-4.9220255 6.2290374-1.6735007 1.2730562-3.641398 2.0807157-5.8882324 2.4229824-.4831332.6204317-1.0424544 1.2020113-1.6705599 1.7530155L8.19619057 14l.44900077-.3051981.38827573-.2727149.08979218-.0648188.08742977-.0639068.33157817-.2508269.31571201-.2535128.3173916-.270021c1.2166338-1.0619741 2.1052536-2.2277033 2.6216419-3.5862846.5947531-1.5647535.7368152-3.72481676.4028366-6.47043174l-.0566929-.43838281L13.1411515 2.007l-.5386794.01100621c-4.66293544.12377413-7.76668695.88288442-9.27381872 2.19128373-.98412728.85435891-1.35291385 1.98548699-1.28840574 3.57247956l.00439583.0971542.00529798.0971136.03078747.3945121.01023927.101758.01131363.1036563.05657231.4400705.07605847.4962931c.01920309.1180662.03998567.2418289.06243847.3723094l.0349432.2008868.15437783.8887816.10476854.6710232c.01936529.1461133.03210618.2695803.04263348.4017578l.0146821.208719.06728066 1.0375449.03472635.4144255L2.78119057 14l-2.00834584.0012477c-.0249872-.2389957-.04655112-.4933156-.06574728-.7643552l-.0190768-.2867277-.04548124-.7135636-.02930626-.2872344-.05359635-.3681249-.30262541-1.7711464-.08294382-.5443143-.06227735-.4904408C.0767532 8.4611666.05427097 8.167395.04189786 7.8629985-.0451933 5.72043043.51446154 4.00387849 2.01752324 2.69901256 4.07329182.91432044 7.88567385.05004361 13.4999457.00211325L14 0h6.5Zm0 2-5.3422224.00149806c.4056846 3.14680691.2504112 5.69053254-.491256 7.64180674-.0323829.0851974-.0658734.1697033-.1004614.2535321 1.2266269-.367004 2.325421-.9217549 3.301027-1.6639126.7739561-.5887596 1.4655827-1.1745881 2.0514381-1.72870732l.3746432-.36439935C21.3685452 5.06260743 22 4.13781462 22 3.5956633c0-.90864927-.526891-1.52425329-1.3514469-1.58984927L20.5 2ZM.03319057 16H24.0331906v2H.03319057v-2Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/OrganRemovalLung.tsx
var React38 = __toESM(require("react"));
function OrganRemovalLung() {
  return /* @__PURE__ */ React38.createElement("svg", { width: "24", height: "22", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React38.createElement(
    "path",
    {
      d: "M24 20v2H0v-2h24ZM13 0v6.536l.4254789.35980766c.1789802-.55506003.4292511-1.05203056.7749375-1.57047981 1.6924719-2.53831366 4.8465341-1.32359326 7.1184945 2.02335828l.1408278.21194616c1.7818056 2.73954641 2.5370551 6.31956921 2.5370551 10.02999151 0 .1409585-.0032351.2779051-.0096871.4108708l-1.9991334-.0001105c.0060564-.1274122.0088205-.264176.0088205-.4107603 0-3.3584307-.6799388-6.5814667-2.2136346-8.93954143-1.6272583-2.50192831-3.2806449-3.17320154-3.9187217-2.21623491-.3725387.55872134-.5928089 1.11914411-.7159123 1.91870924l3.997417 3.383057-1.2918844 1.5267726L15.013 10.859l.0059132 1.5362305-.0080054.9189669-.0071671.5053468-.0035708.5433887.0031399.4868643c.0011374.0767286.0025954.1513232.0043947.2238944l.0150551.4120308c.0032464.0649199.0068752.1280376.0109069.1894635l.0291889.3491409c.0801552.7714246.2473281 1.2546369.5578918 1.7530926.0495017.0794504.1001085.1540361.1527507.2242375l-2.2893767-.000706c-.2692336-.6373473-.4003997-1.3170932-.4536943-2.2730621l-.0198345-.4805838c-.0023927-.083945-.0043495-.1698935-.0059009-.2579648L13 14.4344833l.0035596-.6115362.014577-1.1618047-.0068605-1.7846479c.0001424-.1088398.0006087-.215383.0014285-.3197275l.0093984-.6004642c.0065556-.2673454.0163167-.5191364.0299252-.7574896L12 8.309l-1.0550619.8928396c.0076209.1338644.0140303.2719661.0193417.4146795l.0104109.3397837.0093985.6004642.0009683.158178.0004602.1615495-.0068605 1.7846479.0145769 1.1618047.0035597.6115362-.0046915.5548569-.002635.1305297-.0032659.1274351-.0198346.4805838c-.0532945.9559689-.1844607 1.6357148-.4536942 2.2730621l-2.28937668.000706c.05264218-.0702014.10324894-.1447871.15275066-.2242375.27605667-.4430717.43881685-.8740993.52787319-1.5062093l.03001859-.2468833.02918894-.3491409.00574792-.0934215.005159-.096042.01505507-.4120308.00244556-.1103881.00194911-.1135063.00313995-.4868643-.0035708-.5433887-.00716716-.5053468-.0080054-.9189669L8.983 10.862l-2.83705776 2.4013863-1.29188448-1.5267726 3.99451815-3.38105925c-.12304406-.80062962-.34337076-1.36152044-.71621966-1.92070699-.6380768-.95696663-2.29146333-.2856934-3.9187217 2.21623491C2.67993881 11.0091571 2 14.2321931 2 17.5906238c0 .1465843.00276405.2833481.00882049.4107603l-1.99913335.0001105C.00323504 17.8685289 0 17.7315823 0 17.5906238c0-3.5558214.69362325-6.9918835 2.31965643-9.68322209l.21739868-.34676942.14082777-.21194616c2.27196044-3.34695154 5.42602266-4.56167194 7.11849447-2.02335828.34610345.51907464.59656105 1.01661871.77558495 1.57248873L11 6.536V0h2Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/OrganRemovalPancreas.tsx
var React39 = __toESM(require("react"));
function OrganRemovalPancreas() {
  return /* @__PURE__ */ React39.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React39.createElement(
    "path",
    {
      d: "M23 17.997C23.5523 17.997 24 18.4447 24 18.997C24 19.5515 23.5523 19.9992 23 19.9992H1C0.447715 19.9992 0 19.5515 0 18.9992C0 18.4447 0.447715 17.997 1 17.997H23ZM21.0079 4C24.6275 4 25.1647 8.07758 21.4182 9.76352C20.6802 10.0956 20.0077 10.3796 19.3376 10.6418C18.9733 10.7844 18.6063 10.9219 18.2258 11.0583L16.7705 11.5575C16.3175 11.7066 15.8303 11.86 15.1082 12.0797L10.7329 13.3867C10.3127 13.5115 9.9236 13.633 9.56346 13.7521L9.381 13.8122L9.73459 14.0261C10.5548 14.5481 11.0684 15.1432 11.1567 16.0063L9.04397 16.0081C8.9831 15.9432 8.89722 15.8727 8.78 15.7921L8.63804 15.7008C8.51101 15.6261 7.96328 15.2956 7.80479 15.1695C7.6492 15.0457 7.5174 14.911 7.41897 14.7575L7.346 14.6272L7.20557 14.6997C6.40148 15.1184 5.91615 15.5387 5.64206 16.007L1.15581 16.0082C0.432261 15.0197 0 13.8125 0 12.4281C0 8.42769 2.16589 6.48424 7.66668 5.20207L8.21846 5.07807C12.0381 4.25061 15.4183 4.01437 19.9354 4H21.0079ZM21.0079 6H19.9514C15.8047 6.01307 12.6589 6.21726 9.24701 6.90608L8.44249 7.07654C3.50092 8.1773 2 9.46863 2 12.4281C2 13.7004 2.56957 14.7755 3.46835 15.5617L3.592 15.6652L3.60082 15.6427C4.22717 13.9431 6.03564 12.7343 9.82402 11.5719L14.8566 10.0652C15.79 9.77873 16.2973 9.61065 16.9932 9.37136C17.5626 9.17556 18.0889 8.9828 18.6088 8.77936C19.2469 8.52969 19.8889 8.25857 20.5975 7.93969C22.4855 7.09005 22.3419 6 21.0079 6Z",
      fill: "currentColor",
      style: { fill: "currentColor", fillOpacity: 1 }
    }
  ));
}

// src/components/Icons/PancreasPlacedInPancreaspak.tsx
var React40 = __toESM(require("react"));
function PancreasPlacedInPancreaspak() {
  return /* @__PURE__ */ React40.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React40.createElement(
    "path",
    {
      d: "M23.0003 12.5016C23.4589 12.7309 23.6642 13.2651 23.4935 13.7357L23.4473 13.8431L21.9998 16.7366L22.0002 20.5016C22.0002 21.0144 21.6142 21.437 21.117 21.4948L21.0003 21.5016C20.448 21.5016 20.0003 21.0539 20.0003 20.5016V17.5016H4.00026V20.5016C4.00026 21.0539 3.55254 21.5016 3.00026 21.5016C2.44796 21.5016 2.00022 21.0539 2.00017 20.5016L1.99983 16.7366L0.553065 13.8432C0.323713 13.3845 0.479957 12.8338 0.898942 12.5598L1.00026 12.5016C1.45895 12.2722 2.00964 12.4285 2.28372 12.8475L2.34189 12.9488L3.61826 15.5016H20.3813L21.6584 12.9487C21.9055 12.4547 22.5062 12.2546 23.0003 12.5016ZM13.0003 19.5016C13.5525 19.5016 14.0003 19.9493 14.0003 20.5016C14.0003 21.0539 13.5525 21.5016 13.0003 21.5016H11.0003C10.448 21.5016 10.0003 21.0539 10.0003 20.5016C10.0003 19.9493 10.448 19.5016 11.0003 19.5016H13.0003ZM17.7431 2.49805C20.4625 2.49805 20.8735 5.64929 18.1569 6.88413C17.6818 7.10007 17.2482 7.28502 16.8159 7.4559C16.4632 7.59531 16.1068 7.72715 15.7233 7.86034C15.6344 7.89121 15.5503 7.92027 15.4681 7.94841L15.3054 8.00373C14.6038 8.24049 13.9002 8.45359 11.3106 9.23048L11.1458 9.28051L11.1874 9.31458C11.5618 9.64724 11.7961 10.044 11.8392 10.5686L11.8464 10.7484C11.8464 12.3973 10.3849 13.0468 8.42349 12.8017C6.07951 12.5087 4.01078 10.8278 4.01078 8.27265C4.01078 5.4514 5.58136 4.08651 9.38903 3.22979C9.45719 3.21452 9.45719 3.21452 9.52532 3.19954C11.9491 2.66919 14.0915 2.51227 16.9223 2.49866L17.7431 2.49805ZM8.93278 10.1475L8.92282 10.1536C8.62771 10.3301 8.4354 10.5058 8.3145 10.6936L8.28278 10.7465L8.31461 10.7553C8.37308 10.7683 8.43211 10.78 8.49163 10.7903L8.67156 10.8171C9.49143 10.9196 9.77602 10.8515 9.83436 10.7791C9.81865 10.7676 9.79304 10.7517 9.744 10.7202L9.68672 10.6833C9.71974 10.7045 9.58763 10.6258 9.43769 10.5314L9.28725 10.4348C9.21451 10.387 9.14959 10.3423 9.11089 10.3112C9.07768 10.2846 9.04566 10.2571 9.01495 10.2289L8.93278 10.1475ZM17.4948 4.49778C14.5086 4.49322 12.3588 4.62686 9.95284 5.15332C9.89043 5.16704 9.89043 5.16704 9.82806 5.18101C6.83045 5.85547 6.01078 6.56779 6.01078 8.27265C6.01078 8.78994 6.18105 9.25159 6.47035 9.63615L6.55178 9.73751L6.56479 9.71544C7.13985 8.78033 8.33626 8.0675 10.4306 7.4086L10.7359 7.31483C13.1739 6.58342 13.921 6.35748 14.572 6.14017L14.7336 6.08574C14.8413 6.04919 14.95 6.01173 15.0671 5.97105C15.4247 5.84686 15.7548 5.72474 16.0807 5.59592C16.4808 5.43778 16.8837 5.26591 17.3293 5.0634C18.1982 4.66844 18.1759 4.49805 17.7431 4.49805L17.4948 4.49778Z",
      fill: "currentColor",
      style: { fill: "currentColor", fillOpacity: 1 }
    }
  ));
}

// src/components/Icons/PancreasRemovedFromPancreaspak.tsx
var React41 = __toESM(require("react"));
function PancreasRemovedFromPancreaspak() {
  return /* @__PURE__ */ React41.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React41.createElement(
    "path",
    {
      d: "M23.0003 12.5016C23.4589 12.7309 23.6642 13.2651 23.4935 13.7357L23.4473 13.8431L21.9998 16.7366L22.0002 20.5016C22.0002 21.0144 21.6142 21.437 21.117 21.4948L21.0003 21.5016C20.448 21.5016 20.0003 21.0539 20.0003 20.5016V17.5016H4.00026V20.5016C4.00026 21.0539 3.55254 21.5016 3.00026 21.5016C2.44796 21.5016 2.00022 21.0539 2.00017 20.5016L1.99983 16.7366L0.553065 13.8432C0.323713 13.3845 0.479957 12.8338 0.898942 12.5598L1.00026 12.5016C1.45895 12.2722 2.00964 12.4285 2.28372 12.8475L2.34189 12.9488L3.61826 15.5016H20.3813L21.6584 12.9487C21.9055 12.4547 22.5062 12.2546 23.0003 12.5016ZM13.0003 19.5016C13.5525 19.5016 14.0003 19.9493 14.0003 20.5016C14.0003 21.0539 13.5525 21.5016 13.0003 21.5016H11.0003C10.448 21.5016 10.0003 21.0539 10.0003 20.5016C10.0003 19.9493 10.448 19.5016 11.0003 19.5016H13.0003ZM17.7431 2.49805C20.4625 2.49805 20.8735 5.64929 18.1569 6.88413C17.6818 7.10007 17.2482 7.28502 16.8159 7.4559C16.4632 7.59531 16.1068 7.72715 15.7233 7.86034C15.6344 7.89121 15.5503 7.92027 15.4681 7.94841L15.3054 8.00373C14.6038 8.24049 13.9002 8.45359 11.3106 9.23048L11.1458 9.28051L11.1874 9.31458C11.5618 9.64724 11.7961 10.044 11.8392 10.5686L11.8464 10.7484C11.8464 12.3973 10.3849 13.0468 8.42349 12.8017C6.07951 12.5087 4.01078 10.8278 4.01078 8.27265C4.01078 5.4514 5.58136 4.08651 9.38903 3.22979C9.45719 3.21452 9.45719 3.21452 9.52532 3.19954C11.9491 2.66919 14.0915 2.51227 16.9223 2.49866L17.7431 2.49805ZM8.93278 10.1475L8.92282 10.1536C8.62771 10.3301 8.4354 10.5058 8.3145 10.6936L8.28278 10.7465L8.31461 10.7553C8.37308 10.7683 8.43211 10.78 8.49163 10.7903L8.67156 10.8171C9.49143 10.9196 9.77602 10.8515 9.83436 10.7791C9.81865 10.7676 9.79304 10.7517 9.744 10.7202L9.68672 10.6833C9.71974 10.7045 9.58763 10.6258 9.43769 10.5314L9.28725 10.4348C9.21451 10.387 9.14959 10.3423 9.11089 10.3112C9.07768 10.2846 9.04566 10.2571 9.01495 10.2289L8.93278 10.1475ZM17.4948 4.49778C14.5086 4.49322 12.3588 4.62686 9.95284 5.15332C9.89043 5.16704 9.89043 5.16704 9.82806 5.18101C6.83045 5.85547 6.01078 6.56779 6.01078 8.27265C6.01078 8.78994 6.18105 9.25159 6.47035 9.63615L6.55178 9.73751L6.56479 9.71544C7.13985 8.78033 8.33626 8.0675 10.4306 7.4086L10.7359 7.31483C13.1739 6.58342 13.921 6.35748 14.572 6.14017L14.7336 6.08574C14.8413 6.04919 14.95 6.01173 15.0671 5.97105C15.4247 5.84686 15.7548 5.72474 16.0807 5.59592C16.4808 5.43778 16.8837 5.26591 17.3293 5.0634C18.1982 4.66844 18.1759 4.49805 17.7431 4.49805L17.4948 4.49778Z",
      fill: "currentColor",
      style: { fill: "currentColor", fillOpacity: 1 }
    }
  ));
}

// src/components/Icons/PerfusionStart.tsx
var React42 = __toESM(require("react"));
function PerfusionStart() {
  return /* @__PURE__ */ React42.createElement("svg", { width: "22", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React42.createElement("g", { fill: "currentColor" }, /* @__PURE__ */ React42.createElement("path", { d: "M6.18127696 19.267068c.51392253.6340597 1.07228265 1.2577677 1.66031961 1.8597034.70544689.7221206 1.79218053.9816491 2.81325223.8298486.3024937.6517853.7041546 1.2490482 1.1845472 1.7729405-1.8527159.5858496-4.02512318.2312896-5.42843321-1.2051887-1.09940988-1.1253953-2.10143828-2.3108856-2.93615697-3.5144489l.12210269-.0056262c.84186568-.0255996 1.70139708.0615566 2.58436845.2627713Zm2.77658172-3.3483134.39884292.147027c.3772059.1440241.7518669.2713682 1.1240673.3820514-.2406806.6117897-.3968787 1.266379-.4551375 1.9489152-.3264116-.0927545-.654443-.1985536-.9834901-.3155028l-.39884287-.147027c-3.03085832-1.1572368-5.89741589-1.2375896-8.64338312-.2509185l.0001012-2.1061351c2.87596782-.8712793 5.87225083-.7550845 8.95784217.3415898Zm0-4 .39884292.147027c1.3906827.530988 2.7467743.8352538 4.0724973.9137502-.7688095.4553873-1.4423228 1.0549391-1.9843498 1.7607431-.7947355-.1524298-1.5956669-.3721928-2.4027078-.6590295l-.39884287-.147027c-3.03085832-1.1572368-5.89741589-1.2375896-8.64338312-.2509185l.0001012-2.1061351c2.87596782-.8712793 5.87225083-.7550845 8.95784217.3415898ZM11 .11257411l.0006285 5.32225163c.2443846-.18248305.4730112-.38653333.6829551-.61015592l.2036081-.2300728 2.3662228-2.83769581 3.0530368 3.05113197-2.2646504 3.1685324c-.3147967.44044037-.3068471 1.03435892.0196184 1.46621427.3386991.44802498.6334675.90688635.8839497 1.37607345-.7333864.1470161-1.4762019.2046096-2.2342498.1726457l-.0462696-.0693511-.3206902-.4458018c-.6935579-1.05297094-.7117998-2.41586684-.0466666-3.48701683l.1171844-.17572048L14.693 5.024l-.306-.306-.9637588 1.15743738c-.7939641.95216246-1.8184411 1.68260768-2.9735678 2.1232123l-.2914457.10407338-.1333794.04377454c.6625768.77099237 1.173853 1.6121753 1.530174 2.5211656-.3657361-.0907809-.7353482-.2019717-1.1093852-.3328729l-.3755324-.1374455-.4194977-.1549145c-.3012434-.10746603-.6021195-.20665257-.902568-.29754598-.28217322-.36553456-.60893451-.71543228-.9798901-1.04967036l-.01415928-.01019679-.32012732.03976639-.58490561.05658508c-.55001959.05952095-1.03683197.15616334-1.46312474.29171075-1.1530889-.11118184-2.29696445-.09549518-3.42736612.04744399.41528233-.58199685.96279417-1.06252709 1.63637896-1.43678307L.52930466 5.05648178l3.40932882-3.40932882L6 3.364V1.77924078l5-1.66666667ZM4.061 4.353l-.59.59 2.30664837 1.97913312.22115765-.04024613.00049864-.91431288L4.061 4.353ZM9 2.887 8 3.22l.00032386 3.39852593a10.1889283 10.1889283 0 0 0 .87918324-.20846438l.11979756-.03648744L9 2.887ZM17 14c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5Zm-1.25 2.5v5l4-2.5-4-2.5Z" })));
}

// src/components/Icons/PerfusionStop.tsx
var React43 = __toESM(require("react"));
function PerfusionStop() {
  return /* @__PURE__ */ React43.createElement("svg", { width: "22", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React43.createElement("g", { fill: "currentColor" }, /* @__PURE__ */ React43.createElement("path", { d: "M6.18127696 19.267068c.51392253.6340597 1.07228265 1.2577677 1.66031961 1.8597034.70544689.7221206 1.79218053.9816491 2.81325223.8298486.3024937.6517853.7041546 1.2490482 1.1845472 1.7729405-1.8527159.5858496-4.02512318.2312896-5.42843321-1.2051887-1.09940988-1.1253953-2.10143828-2.3108856-2.93615697-3.5144489l.12210269-.0056262c.84186568-.0255996 1.70139708.0615566 2.58436845.2627713Zm2.77658172-3.3483134.39884292.147027c.3772059.1440241.7518669.2713682 1.1240673.3820514-.2406806.6117897-.3968787 1.266379-.4551375 1.9489152-.3264116-.0927545-.654443-.1985536-.9834901-.3155028l-.39884287-.147027c-3.03085832-1.1572368-5.89741589-1.2375896-8.64338312-.2509185l.0001012-2.1061351c2.87596782-.8712793 5.87225083-.7550845 8.95784217.3415898Zm0-4 .39884292.147027c1.3906827.530988 2.7467743.8352538 4.0724973.9137502-.7688095.4553873-1.4423228 1.0549391-1.9843498 1.7607431-.7947355-.1524298-1.5956669-.3721928-2.4027078-.6590295l-.39884287-.147027c-3.03085832-1.1572368-5.89741589-1.2375896-8.64338312-.2509185l.0001012-2.1061351c2.87596782-.8712793 5.87225083-.7550845 8.95784217.3415898ZM11 .11257411l.0006285 5.32225163c.2443846-.18248305.4730112-.38653333.6829551-.61015592l.2036081-.2300728 2.3662228-2.83769581 3.0530368 3.05113197-2.2646504 3.1685324c-.3147967.44044037-.3068471 1.03435892.0196184 1.46621427.3386991.44802498.6334675.90688635.8839497 1.37607345-.7333864.1470161-1.4762019.2046096-2.2342498.1726457l-.0462696-.0693511-.3206902-.4458018c-.6935579-1.05297094-.7117998-2.41586684-.0466666-3.48701683l.1171844-.17572048L14.693 5.024l-.306-.306-.9637588 1.15743738c-.7939641.95216246-1.8184411 1.68260768-2.9735678 2.1232123l-.2914457.10407338-.1333794.04377454c.6625768.77099237 1.173853 1.6121753 1.530174 2.5211656-.3657361-.0907809-.7353482-.2019717-1.1093852-.3328729l-.3755324-.1374455-.4194977-.1549145c-.3012434-.10746603-.6021195-.20665257-.902568-.29754598-.28217322-.36553456-.60893451-.71543228-.9798901-1.04967036l-.01415928-.01019679-.32012732.03976639-.58490561.05658508c-.55001959.05952095-1.03683197.15616334-1.46312474.29171075-1.1530889-.11118184-2.29696445-.09549518-3.42736612.04744399.41528233-.58199685.96279417-1.06252709 1.63637896-1.43678307L.52930466 5.05648178l3.40932882-3.40932882L6 3.364V1.77924078l5-1.66666667ZM4.061 4.353l-.59.59 2.30664837 1.97913312.22115765-.04024613.00049864-.91431288L4.061 4.353ZM9 2.887 8 3.22l.00032386 3.39852593a10.1889283 10.1889283 0 0 0 .87918324-.20846438l.11979756-.03648744L9 2.887ZM17 14c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5Zm-2 3h4v4h-4v-4Z" })));
}

// src/components/Icons/PlaneArrivalDonor.tsx
var React44 = __toESM(require("react"));
function PlaneArrivalDonor() {
  return /* @__PURE__ */ React44.createElement("svg", { width: "20", height: "19", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React44.createElement(
    "path",
    {
      d: "M.5 17h19v2H.5v-2Zm16.84-3.15c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42L10.05.51 8.12 0v8.28L3.15 6.95l-.93-2.32-1.45-.39v5.17l16.57 4.44Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/PlaneArrivalRecipient.tsx
var React45 = __toESM(require("react"));
function PlaneArrivalRecipient() {
  return /* @__PURE__ */ React45.createElement("svg", { width: "20", height: "19", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React45.createElement(
    "path",
    {
      d: "M.5 17h19v2H.5v-2Zm16.84-3.15c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42L10.05.51 8.12 0v8.28L3.15 6.95l-.93-2.32-1.45-.39v5.17l16.57 4.44Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/PlaneDepartureDonor.tsx
var React46 = __toESM(require("react"));
function PlaneDepartureDonor() {
  return /* @__PURE__ */ React46.createElement("svg", { width: "22", height: "18", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React46.createElement(
    "path",
    {
      d: "M1.5 16h19v2h-19v-2Zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L13.92 7 7.02.57l-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 2.59 4.49s7.12-1.9 16.57-4.43c.81-.23 1.28-1.05 1.07-1.85Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/PlaneDepartureRecipient.tsx
var React47 = __toESM(require("react"));
function PlaneDepartureRecipient() {
  return /* @__PURE__ */ React47.createElement("svg", { width: "22", height: "18", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React47.createElement(
    "path",
    {
      d: "M1.5 16h19v2h-19v-2Zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L13.92 7 7.02.57l-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 2.59 4.49s7.12-1.9 16.57-4.43c.81-.23 1.28-1.05 1.07-1.85Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/PortalReperfusion.tsx
var React48 = __toESM(require("react"));
function PortalReperfusion() {
  return /* @__PURE__ */ React48.createElement("svg", { width: "14", height: "18", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React48.createElement(
    "path",
    {
      d: "M12 17.41 13.41 16 10 12.59 8.59 14 12 17.41ZM2.5 5H6v5.59L.59 16 2 17.41l6-6V5h3.5L7 .5 2.5 5Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/RightLungAnastomosisComplete.tsx
var React49 = __toESM(require("react"));
function RightLungAnastomosisComplete() {
  return /* @__PURE__ */ React49.createElement("svg", { width: "24", height: "22", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React49.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React49.createElement(
    "path",
    {
      d: "m21.3189109 7.34868613.1408278.21194616c1.7818056 2.73954641 2.5370551 6.31956921 2.5370551 10.02999151 0 3.061815-1.5263547 4.230764-4.3946412 3.8231386l-1.1427057-.185628-.5719491-.1016883c-2.0961445-.3988215-3.1111656-.9222343-3.9642318-2.2914079-.5783041-.9281798-.8161638-1.7317909-.8928391-3.1071494l-.0198345-.4805838c-.0023927-.083945-.0043495-.1698935-.0059009-.2579648L13 14.4344833l.0035596-.6115362.014577-1.1618047-.0068605-1.7846479c.0001424-.1088398.0006087-.215383.0014285-.3197275l.0093984-.6004642c.0065648-.2677224.0163443-.5198467.0299828-.758498l4.801972 4.0655815 1.2918844-1.5267726-5.7204633-4.84080604c.1789802-.55506003.4292511-1.05203056.7749375-1.57047981 1.6924719-2.53831366 4.8465341-1.32359326 7.1184945 2.02335828Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ), /* @__PURE__ */ React49.createElement(
    "path",
    {
      d: "M1 17.5906238c0 2.6470222 1.20453647 3.1775661 3.45927906 2.801326 2.25474258-.3762401 3.78850077-.5176214 4.76550812-2.085721.97700732-1.5680996.75309337-3.4620471.75309337-5.9109983 0-2.4489511.18076845-4.72399762-1.01351375-6.51514284-1.19428219-1.79114523-3.654189-.74905809-5.58902197 2.22576967C1.44051187 11.0806851 1 14.9436016 1 17.5906238Z",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ), /* @__PURE__ */ React49.createElement("path", { stroke: "currentColor", strokeWidth: "2", d: "M12 0v7l-6.5 5.5" })));
}

// src/components/Icons/RightLungRemovedFromLungguard.tsx
var React50 = __toESM(require("react"));
function RightLungRemovedFromLungguard() {
  return /* @__PURE__ */ React50.createElement("svg", { width: "24", height: "22", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React50.createElement(
    "path",
    {
      d: "m22.1055728 12.5527864 1.7888544.8944272L21.9995728 17.235 22 22h-2v-4H4v4H2l-.00042719-4.765-1.894-3.7877864 1.78885438-.8944272L3.618 16h16.763l1.7245728-3.4472136ZM14 20v2h-4v-2h4ZM13 0l-.0004272 3.736.0364367-.07515474c.0836407-.16240394.1797395-.3233746.2899639-.48810958 1.2640993-1.88924887 3.5345051-1.03223424 5.1028562 1.23879617l.1223275.1822053c1.1796096 1.8073438 1.6741648 4.14345924 1.6741648 6.56129255 0 2.163055-1.1595722 3.0583529-3.1623183 2.7932771l-.7844221-.1256134c-1.6794354-.2794813-2.4733956-.6253481-3.1351256-1.683726-.5219523-.8348161-.6446991-1.5068287-.6434464-3.0177l.0114415-1.06594113-.0036727-1.31180012c.0005486-.09284647.001511-.18312849.0029366-.27099998L12.519 6.18355996l2.9727359 2.50776589 1.2892555-1.52899316L12.9995728 3.973 13 4.90386914 11.4755728 6.188l.0090342.28452617c.0007128.04393575.0013098.08847412.0017972.13363437l.0011394.13736561-.0036727 1.31180012.0114416 1.06594113c.0012527 1.5108713-.1214941 2.1828839-.6434465 3.0177-.66173 1.0583779-1.45569018 1.4042447-3.13512561 1.683726l-.7844221.1256134C4.9295722 14.2133826 3.77 13.3180847 3.77 11.1550297c0-2.41783331.49455527-4.75394875 1.67416484-6.56129255l.1223275-.1822053c1.56835112-2.27103041 3.8387569-3.12804504 5.10285616-1.23879617.1281765.19156502.2372514.37803969.3298468.56759726L11 0h2ZM9.00711829 4.28493647c-.09266982-.13849889-.15486681-.1540668-.39543638-.05673612-.44197511.17881621-.99259172.69244876-1.4926806 1.45866205C6.1887464 7.11215639 5.77 9.0901758 5.77 11.1550297l.0004787.1245344.00551579.215191c.02258388.4514366.12540415.5575843.56550675.5166989l.21001475-.0259463 1.04466799-.1713803.36239699-.0701853c.7132056-.1523912.97900612-.3158496 1.197464-.6652535.20075153-.3210841.29291394-.6456005.32505147-1.2781766l.01129153-.3433699.00263639-.4031751-.01019503-.87891322L9.48457281 7.867l-.97630867.82432585-1.28925556-1.52899316 2.18012426-1.83850948c-.07164948-.43722272-.19390842-.74280891-.39201455-1.03888674Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/Search.tsx
var React51 = __toESM(require("react"));
function Search() {
  return /* @__PURE__ */ React51.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React51.createElement(
    "path",
    {
      d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5Zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/Settings.tsx
var React52 = __toESM(require("react"));
function Settings() {
  return /* @__PURE__ */ React52.createElement("svg", { height: "24", width: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React52.createElement(
    "path",
    {
      d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94 0 .31.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58ZM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/StartLogger.tsx
var React53 = __toESM(require("react"));
function StartLogger() {
  return /* @__PURE__ */ React53.createElement("svg", { width: "20", height: "20", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React53.createElement(
    "path",
    {
      d: "m8 14.5 6-4.5-6-4.5v9ZM10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/StartSession.tsx
var React54 = __toESM(require("react"));
function StartSession() {
  return /* @__PURE__ */ React54.createElement("svg", { width: "20", height: "20", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React54.createElement(
    "path",
    {
      d: "m8 14.5 6-4.5-6-4.5v9ZM10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/StartWean.tsx
var React55 = __toESM(require("react"));
function StartWean() {
  return /* @__PURE__ */ React55.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React55.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.5 1.25001C12.5 0.928564 12.3455 0.626716 12.0847 0.438765C11.8239 0.250814 11.4887 0.199675 11.1838 0.301324L8.18377 1.30132C7.77543 1.43744 7.5 1.81958 7.5 2.25001V3.11497L6.14019 1.98179C5.74286 1.65068 5.15861 1.67718 4.79289 2.0429L2.79289 4.0429C2.59593 4.23986 2.49005 4.51005 2.50074 4.78838C2.51143 5.06672 2.63772 5.32799 2.84921 5.50926L5.09161 7.43132C4.67669 7.66281 4.30236 7.93981 3.97361 8.26652C2.88632 9.34706 2.4444 10.8233 2.50554 12.5342C2.57595 14.5044 3.53265 16.5078 4.60995 18.1771C5.70226 19.8696 6.99993 21.3418 7.91092 22.2744C8.41645 22.7918 9.00741 23.1661 9.64006 23.4079C10.1559 23.6051 10.734 23.3467 10.9312 22.8308C11.1284 22.315 10.87 21.7369 10.3542 21.5397C9.9792 21.3964 9.63601 21.1782 9.34155 20.8768C8.49002 20.0051 7.28775 18.638 6.29038 17.0926C5.27801 15.5239 4.5553 13.8909 4.50427 12.4628C4.45698 11.1396 4.79747 10.2674 5.38342 9.68513C5.99039 9.08192 7.00863 8.64147 8.60875 8.50638L8.62792 8.50458L9.06879 8.4588L9.08893 8.4565C9.14486 8.44954 9.20074 8.44219 9.25656 8.43446C10.3234 9.39227 11.015 10.4687 11.3714 11.6651C11.5165 12.152 11.6065 12.6342 11.6436 13.1129C11.6862 13.6635 12.1672 14.0753 12.7178 14.0327C13.2684 13.99 13.6802 13.5091 13.6376 12.9585C13.5892 12.333 13.472 11.7112 13.2882 11.0941C12.9369 9.91501 12.3437 8.84885 11.5249 7.89619L11.6522 7.85471L11.6582 7.85271C12.9324 7.42823 14.0631 6.65693 14.9232 5.62542L15.8877 4.4687L16.1935 4.77428L14.9118 6.56744C14.0916 7.71733 14.1115 9.26598 14.9604 10.3942L15.1618 10.6678C15.3186 10.8917 15.4608 11.1168 15.5888 11.343C15.8609 11.8237 16.4711 11.9928 16.9517 11.7207C17.4323 11.4487 17.6014 10.8385 17.3294 10.3579C17.1665 10.0702 16.9874 9.78748 16.7924 9.50968L16.7793 9.4915L16.5678 9.20401L16.5602 9.19397C16.2341 8.76245 16.226 8.1692 16.54 7.72888L18.3135 5.24764C18.5979 4.84975 18.5528 4.30454 18.2068 3.95883L16.5274 2.28047C16.3288 2.08194 16.0558 1.97609 15.7752 1.98882C15.4947 2.00155 15.2324 2.13167 15.0525 2.34737L13.3871 4.34458C13.1241 4.66003 12.8261 4.94183 12.5 5.18524V1.25001ZM10.5 6.12365V2.63743L9.5 2.97077L9.5 6.36802C9.83708 6.30349 10.1708 6.22195 10.5 6.12365ZM5.56137 4.10285L7.5 5.71838V6.63071C7.4252 6.64331 7.35102 6.65666 7.27747 6.67076L4.9707 4.69353L5.56137 4.10285Z",
      fill: "currentColor",
      style: { fill: "currentColor", fillOpacity: 1 }
    }
  ), /* @__PURE__ */ React55.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.6653 22.5L15.8903 23.6C15.9236 23.7167 15.9778 23.8125 16.0528 23.8875C16.1278 23.9625 16.232 24 16.3653 24H17.5653C17.6986 24 17.8028 23.9625 17.8778 23.8875C17.9528 23.8125 18.007 23.7167 18.0403 23.6L18.2653 22.5C18.4653 22.4167 18.6528 22.325 18.8278 22.225C19.0028 22.125 19.1736 22.0083 19.3403 21.875L20.4153 22.225C20.532 22.2583 20.6403 22.2542 20.7403 22.2125C20.8403 22.1708 20.9236 22.1 20.9903 22L21.5903 20.975C21.657 20.875 21.6778 20.7667 21.6528 20.65C21.6278 20.5333 21.5736 20.4333 21.4903 20.35L20.6653 19.625C20.6986 19.375 20.7153 19.1625 20.7153 18.9875C20.7153 18.8125 20.6986 18.6 20.6653 18.35L21.4903 17.625C21.5736 17.5417 21.6278 17.4417 21.6528 17.325C21.6778 17.2083 21.657 17.1 21.5903 17L20.9903 15.975C20.9236 15.875 20.8361 15.8042 20.7278 15.7625C20.6195 15.7208 20.507 15.7167 20.3903 15.75L19.3403 16.125C19.1736 15.9917 19.0028 15.875 18.8278 15.775C18.6528 15.675 18.4653 15.5833 18.2653 15.5L18.0403 14.4C18.007 14.2833 17.9528 14.1875 17.8778 14.1125C17.8028 14.0375 17.6986 14 17.5653 14H16.3653C16.232 14 16.1278 14.0375 16.0528 14.1125C15.9778 14.1875 15.9236 14.2833 15.8903 14.4L15.6653 15.5C15.4653 15.5833 15.2778 15.6792 15.1028 15.7875C14.9278 15.8958 14.757 16.0167 14.5903 16.15L13.5403 15.775C13.4236 15.7417 13.3111 15.7458 13.2028 15.7875C13.0945 15.8292 13.007 15.9 12.9403 16L12.3403 17.025C12.2736 17.125 12.2528 17.2333 12.2778 17.35C12.3028 17.4667 12.357 17.5667 12.4403 17.65L13.2653 18.375C13.232 18.625 13.2153 18.8375 13.2153 19.0125C13.2153 19.1875 13.232 19.4 13.2653 19.65L12.4403 20.375C12.357 20.4583 12.3028 20.5583 12.2778 20.675C12.2528 20.7917 12.2736 20.9 12.3403 21L12.9403 22.025C13.007 22.125 13.0945 22.1958 13.2028 22.2375C13.3111 22.2792 13.4236 22.2833 13.5403 22.25L14.5903 21.875C14.757 22.0083 14.9278 22.125 15.1028 22.225C15.2778 22.325 15.4653 22.4167 15.6653 22.5ZM18.3778 20.4125C17.9861 20.8042 17.5153 21 16.9653 21C16.4153 21 15.9445 20.8042 15.5528 20.4125C15.1611 20.0208 14.9653 19.55 14.9653 19C14.9653 18.45 15.1611 17.9792 15.5528 17.5875C15.9445 17.1958 16.4153 17 16.9653 17C17.5153 17 17.9861 17.1958 18.3778 17.5875C18.7695 17.9792 18.9653 18.45 18.9653 19C18.9653 19.55 18.7695 20.0208 18.3778 20.4125Z",
      fill: "currentColor",
      style: { fill: "currentColor", fillOpacity: 1 }
    }
  ));
}

// src/components/Icons/StopLogger.tsx
var React56 = __toESM(require("react"));
function StopLogger() {
  return /* @__PURE__ */ React56.createElement("svg", { width: "20", height: "20", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React56.createElement(
    "path",
    {
      d: "M10 0c5.52 0 10 4.48 10 10s-4.48 10-10 10S0 15.52 0 10 4.48 0 10 0Zm0 2c-4.416 0-8 3.584-8 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8Zm4 12H6V6h8v8Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/StopSession.tsx
var React57 = __toESM(require("react"));
function StopSession() {
  return /* @__PURE__ */ React57.createElement("svg", { width: "18", height: "18", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React57.createElement(
    "path",
    {
      d: "M12.73 0H5.27L0 5.27v7.46L5.27 18h7.46L18 12.73V5.27L12.73 0ZM16 11.9 11.9 16H6.1L2 11.9V6.1L6.1 2h5.8L16 6.1v5.8Zm-4.17-7.14L9 7.59 6.17 4.76 4.76 6.17 7.59 9l-2.83 2.83 1.41 1.41L9 10.41l2.83 2.83 1.41-1.41L10.41 9l2.83-2.83-1.41-1.41Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/TimeOfDeath.tsx
var React58 = __toESM(require("react"));
function TimeOfDeath() {
  return /* @__PURE__ */ React58.createElement("svg", { width: "20", height: "20", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React58.createElement(
    "path",
    {
      d: "M9.99 0C15.52 0 20 4.48 20 10S15.52 20 9.99 20C4.47 20 0 15.52 0 10S4.47 0 9.99 0ZM10 2c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Zm.5 3v5.25l4.5 2.67-.75 1.23L9 11V5h1.5Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/TimeOfWithdrawal.tsx
var React59 = __toESM(require("react"));
function TimeOfWithdrawal() {
  return /* @__PURE__ */ React59.createElement("svg", { width: "20", height: "20", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React59.createElement(
    "path",
    {
      d: "M9.99 0C15.52 0 20 4.48 20 10S15.52 20 9.99 20C4.47 20 0 15.52 0 10S4.47 0 9.99 0ZM10 2c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Zm.5 3v5.25l4.5 2.67-.75 1.23L9 11V5h1.5Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/Icons/TimeToIncision.tsx
var React60 = __toESM(require("react"));
function TimeToIncision() {
  return /* @__PURE__ */ React60.createElement("svg", { width: "23", height: "21", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React60.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React60.createElement(
    "path",
    {
      d: "m3 19 3.99292893-3.9929289c.00390525-.0039053.01023689-.0039053.01414214 0l.17221825.1722182c.03905243.0390525.03905243.1023689 0 .1414214l-1.65 1.65C5.51053568 16.9894643 5.5 17.0148997 5.5 17.0414214v.8908753c0 .0408905-.02489509.0776613-.06286093.0928477L3 19Z",
      strokeWidth: "1.34",
      fill: "currentColor"
    }
  ), /* @__PURE__ */ React60.createElement(
    "path",
    {
      d: "M9.5 15.5 20.75 4.25c.6903559-.69035594.6903559-1.80964406 0-2.5-.6903559-.69035594-1.8096441-.69035594-2.5 0L7 13",
      strokeWidth: "2"
    }
  )));
}

// src/components/Icons/WarmIschemicTimeStart.tsx
var React61 = __toESM(require("react"));
function WarmIschemicTimeStart() {
  return /* @__PURE__ */ React61.createElement("svg", { width: "16", height: "19", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React61.createElement(
    "path",
    {
      d: "M8 3.36c1.53 2 3.08 4.43 3.71 6.24l2.23 2.23c.03-.27.06-.55.06-.83C14 7.02 8 .2 8 .2S6.82 1.55 5.5 3.39l1.44 1.44c.34-.51.7-1 1.06-1.47ZM1.41 2.14 0 3.55l3.32 3.32C2.55 8.33 2 9.79 2 11c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.95-1.5l2.63 2.63L16 16.72 1.41 2.14ZM8 15c-2.21 0-4-1.79-4-4 0-.69.32-1.62.81-2.64l5.72 5.72c-.7.56-1.57.92-2.53.92Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }
  ));
}

// src/components/LoadGoogle.tsx
var import_api2 = require("@react-google-maps/api");
function AddressAutocomplete2({ libraries = [], children }) {
  const { isLoaded } = (0, import_api2.useJsApiLoader)({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries
  });
  if (!isLoaded) {
    return null;
  }
  return children;
}

// src/components/SessionTrackingMap/index.tsx
var React62 = __toESM(require("react"));
var import_firebase2 = require("@packages/firebase");
var import_utils = require("@packages/utils");
var import_api3 = require("@react-google-maps/api");
var import_react3 = require("react");
var import_md = require("react-icons/md");

// src/components/SessionTrackingMap/getLatLngFromSession.ts
var import_firebase = require("@packages/firebase");
function getLatLngFromSession(session) {
  var _a, _b, _c, _d, _e, _f, _g;
  if (isFlight(session)) {
    return {
      latitude: (_a = session.flightPosition) == null ? void 0 : _a.latitude,
      longitude: (_b = session.flightPosition) == null ? void 0 : _b.longitude,
      heading: (_c = session.flightPosition) == null ? void 0 : _c.heading,
      markerType: "FLIGHT" /* FLIGHT */
    };
  }
  if (isDefaultTracking(session)) {
    return {
      latitude: (_d = session.location) == null ? void 0 : _d.latitude,
      longitude: (_e = session.location) == null ? void 0 : _e.longitude,
      markerType: "DEFAULT" /* DEFAULT */
    };
  }
  if (isAdvancedTracking(session)) {
    return {
      latitude: (_f = session.advancedTracking) == null ? void 0 : _f.latitude,
      longitude: (_g = session.advancedTracking) == null ? void 0 : _g.longitude,
      markerType: "ADVANCED_TRACKING" /* ADVANCED_TRACKING */
    };
  }
  return null;
}
function isFlight(session) {
  if (session.flightPosition == null) {
    return false;
  }
  if (session.flights == null || session.flights.length === 0) {
    return false;
  }
  const currentFlight = session.flights.find(
    (elem) => {
      var _a;
      return elem.state === import_firebase.FlightState.IN_AIR && elem.flightId === ((_a = session.flightPosition) == null ? void 0 : _a.flightId);
    }
  );
  if (currentFlight == null) {
    return false;
  }
  return session.flightPosition.latitude != null && session.flightPosition.longitude != null;
}
function isAdvancedTracking(session) {
  var _a;
  return ((_a = session.advancedTracking) == null ? void 0 : _a.latitude) != null && session.advancedTracking.longitude != null;
}
function isDefaultTracking(session) {
  var _a;
  return ((_a = session.location) == null ? void 0 : _a.latitude) != null && session.location.longitude != null;
}

// src/components/SessionTrackingMap/index.tsx
var DEFAULT_CONTAINER_STYLE = {
  width: "100%",
  height: "600px"
};
function SessionTrackingMap({ sessions, options, InfoWindowContent }) {
  const containerStyle = {
    width: (options == null ? void 0 : options.width) ?? DEFAULT_CONTAINER_STYLE.width,
    height: (options == null ? void 0 : options.height) ?? DEFAULT_CONTAINER_STYLE.height
  };
  const [map, setMap] = (0, import_react3.useState)(null);
  const [activeSessionMarkerId, setActiveSessionMarkerId] = (0, import_react3.useState)(void 0);
  const isAdvancedTrackingActive = (0, import_react3.useMemo)(() => {
    if (sessions.length !== 1) {
      return false;
    }
    const { session } = sessions[0];
    return session.advancedTrackerId != null || isAdvancedTracking(session);
  }, [sessions]);
  const onLoadWrapper = (0, import_react3.useCallback)((gmap) => onLoad(gmap), []);
  const onUnMountWrapper = (0, import_react3.useCallback)(() => onUnMount(), []);
  function onLoad(gmap) {
    setMap(gmap);
  }
  function onUnMount() {
    setMap(null);
  }
  const fitToBounds = (0, import_react3.useCallback)(() => {
    if (map == null) {
      return;
    }
    const mapBounds = new window.google.maps.LatLngBounds();
    for (const { session, locations } of sessions) {
      const location = getLatLngFromSession(session);
      if ((location == null ? void 0 : location.latitude) != null && (location == null ? void 0 : location.longitude) != null) {
        mapBounds.extend({ lat: location.latitude, lng: location.longitude });
      }
      if ((options == null ? void 0 : options.showPolylines) && locations != null && locations.length > 0) {
        locations.forEach(({ latitude, longitude }) => mapBounds.extend({ lat: latitude, lng: longitude }));
      }
    }
    if (sessions.length === 1) {
      const location = getLatLngFromSession(sessions[0].session);
      if ((location == null ? void 0 : location.latitude) != null && (location == null ? void 0 : location.longitude) != null) {
        if (location.markerType === "FLIGHT" /* FLIGHT */) {
          map.setCenter({ lat: location.latitude, lng: location.longitude });
          map.setZoom(6);
        } else if (location.markerType === "ADVANCED_TRACKING" /* ADVANCED_TRACKING */) {
          map.setCenter({ lat: location.latitude, lng: location.longitude });
          map.setZoom(12);
        } else if (location.markerType === "DEFAULT" /* DEFAULT */) {
          map.setCenter({ lat: location.latitude, lng: location.longitude });
          map.setZoom(10);
        }
      }
    } else {
      map.fitBounds(mapBounds);
    }
  }, [map, options == null ? void 0 : options.showPolylines, sessions]);
  const markers = (0, import_react3.useMemo)(() => {
    return sessions.map(({ session }) => {
      const location = getLatLngFromSession(session);
      if ((location == null ? void 0 : location.latitude) == null || (location == null ? void 0 : location.longitude) == null) {
        return null;
      }
      let icon = import_firebase2.ProductUtil.markerSvg(session.product);
      if (location.markerType === "FLIGHT" /* FLIGHT */) {
        icon = import_firebase2.ProductUtil.flightMarkerSvg(session.product, location.heading);
      } else if (location.markerType === "ADVANCED_TRACKING" /* ADVANCED_TRACKING */) {
        icon = import_firebase2.ProductUtil.tiveMarkerSvg(session.product);
      }
      fitToBounds();
      return /* @__PURE__ */ React62.createElement(
        import_api3.Marker,
        {
          key: session.id,
          position: { lat: location.latitude, lng: location.longitude },
          onClick: () => setActiveSessionMarkerId(session.id),
          icon
        },
        session.id === activeSessionMarkerId && (options == null ? void 0 : options.showInfoWindows) && InfoWindowContent ? /* @__PURE__ */ React62.createElement(import_api3.InfoWindow, { onCloseClick: () => setActiveSessionMarkerId(void 0) }, /* @__PURE__ */ React62.createElement(InfoWindowContent, { session })) : null
      );
    }).filter((elem) => elem != null);
  }, [activeSessionMarkerId, fitToBounds, options == null ? void 0 : options.showInfoWindows, sessions]);
  const polylines = (0, import_react3.useMemo)(() => {
    return sessions.map(({ session, locations }) => {
      if (locations == null || locations.length === 0) {
        return null;
      }
      const path = locations.map((location) => ({ lat: location.latitude, lng: location.longitude }));
      fitToBounds();
      return /* @__PURE__ */ React62.createElement(import_api3.Polyline, { key: `polyline-${session.id}`, path, options: { strokeColor: "#000000", strokeOpacity: 0.8, strokeWeight: 3 } });
    }).filter((elem) => elem != null);
  }, [fitToBounds, sessions]);
  const smoothedPolylines = (0, import_react3.useMemo)(() => {
    return sessions.map(({ session, locations }) => {
      if (locations == null || locations.length === 0) {
        return null;
      }
      const path = (0, import_utils.kalmanFilterAll)(locations).map((location) => ({ lat: location.latitude, lng: location.longitude }));
      fitToBounds();
      return /* @__PURE__ */ React62.createElement(
        import_api3.Polyline,
        {
          key: `polyline-smoothed-${session.id}`,
          path,
          options: { strokeColor: import_firebase2.ProductUtil.colors(session.product).primary, strokeOpacity: 0.8, strokeWeight: 3 }
        }
      );
    }).filter((elem) => elem != null);
  }, [fitToBounds, sessions]);
  if (markers.length > 0 || (options == null ? void 0 : options.showPolylines) && polylines.length > 0 || (options == null ? void 0 : options.showPolylines) && smoothedPolylines.length > 0) {
    return /* @__PURE__ */ React62.createElement(React62.Fragment, null, /* @__PURE__ */ React62.createElement(
      import_api3.GoogleMap,
      {
        mapContainerStyle: containerStyle,
        options: { fullscreenControl: false, streetViewControl: false, mapTypeControl: false, maxZoom: 18 },
        onLoad: onLoadWrapper,
        onUnmount: onUnMountWrapper,
        onClick: () => setActiveSessionMarkerId(void 0)
      },
      markers,
      (options == null ? void 0 : options.showPolylines) && polylines,
      (options == null ? void 0 : options.showPolylines) && smoothedPolylines
    ), isAdvancedTrackingActive && /* @__PURE__ */ React62.createElement("div", { className: "position-absolute ms-3 top-0 left-0 mt-3" }, /* @__PURE__ */ React62.createElement(AdvancedTrackingBadge, null)));
  }
  return /* @__PURE__ */ React62.createElement("div", { className: "flex h-full w-full flex-col items-center justify-center text-center", style: { height: containerStyle.height } }, /* @__PURE__ */ React62.createElement("div", { className: "bg-grey-100 bg-product-light mb-6 rounded-full p-6" }, /* @__PURE__ */ React62.createElement(import_md.MdLocationOn, { className: "text-product h-9 w-9" })), /* @__PURE__ */ React62.createElement("div", { className: "mb-3 text-[18px] font-[600]" }, "No location data"), /* @__PURE__ */ React62.createElement("div", { className: "text-muted text-[14px]" }, "Once the sessions location is shared, the map will display the location data in real-time."));
}
function AdvancedTrackingBadge() {
  return /* @__PURE__ */ React62.createElement("div", { className: "d-flex align-items-center rounded-2 bg-white px-2 py-1" }, /* @__PURE__ */ React62.createElement("div", { className: "me-1" }, /* @__PURE__ */ React62.createElement("i", { className: "mdi mdi-circle", style: { color: "#34c38f" } })), /* @__PURE__ */ React62.createElement("div", { className: "text-muted" }, "Advanced Tracking Active"));
}

// src/utils/formatCountry.tsx
var React63 = __toESM(require("react"));
function countryFormatter(code) {
  if (code == null) {
    return "-";
  }
  const { name } = COUNTRIES.find((country) => country.code === code) ?? {};
  if (name == null) {
    return "-";
  }
  return /* @__PURE__ */ React63.createElement("div", { className: "flex items-center truncate" }, /* @__PURE__ */ React63.createElement(
    "img",
    {
      src: `https://purecatamphetamine.github.io/country-flag-icons/3x2/${code}.svg`,
      className: "inline h-4 mr-2 rounded-sm",
      alt: name
    }
  ), name);
}
var formatCountry_default = countryFormatter;

// src/utils/timelineEntryIcon.ts
var import_firebase3 = require("@packages/firebase");
function timelineEntryIcon(type) {
  switch (type) {
    case import_firebase3.TimelineEntryType.START_SESSION:
      return Icons_exports.StartSession;
    case import_firebase3.TimelineEntryType.LEAVE_TX_CENTER:
      return Icons_exports.LeaveTxCenter;
    case import_firebase3.TimelineEntryType.PLANE_DEPARTURE_RECIPIENT:
      return Icons_exports.PlaneDepartureRecipient;
    case import_firebase3.TimelineEntryType.PLANE_ARRIVAL_DONOR:
      return Icons_exports.PlaneArrivalDonor;
    case import_firebase3.TimelineEntryType.ARRIVAL_AT_DONOR:
      return Icons_exports.ArrivalAtDonor;
    case import_firebase3.TimelineEntryType.DONOR_IN_ROOM:
      return Icons_exports.DonorInRoom;
    case import_firebase3.TimelineEntryType.TIME_TO_INCISION:
      return Icons_exports.TimeToIncision;
    case import_firebase3.TimelineEntryType.HEPARIN_ADMINISTERED:
      return Icons_exports.HeparinAdministered;
    case import_firebase3.TimelineEntryType.CROSSCLAMP_AT_DONOR:
      return Icons_exports.CrossclampAtDonor;
    case import_firebase3.TimelineEntryType.ORGAN_REMOVAL:
      return Icons_exports.OrganRemoval;
    case import_firebase3.TimelineEntryType.START_LOGGER:
      return Icons_exports.StartLogger;
    case import_firebase3.TimelineEntryType.LEAVE_DONOR:
      return Icons_exports.LeaveDonor;
    case import_firebase3.TimelineEntryType.PLANE_DEPARTURE_DONOR:
      return Icons_exports.PlaneDepartureDonor;
    case import_firebase3.TimelineEntryType.PLANE_ARRIVAL_RECIPIENT:
      return Icons_exports.PlaneArrivalRecipient;
    case import_firebase3.TimelineEntryType.ARRIVE_AT_RECIPIENT:
      return Icons_exports.ArriveAtRecipient;
    case import_firebase3.TimelineEntryType.STOP_LOGGER:
      return Icons_exports.StopLogger;
    case import_firebase3.TimelineEntryType.CROSSCLAMP_AT_RECIPIENT:
      return Icons_exports.CrossclampAtRecipient;
    case import_firebase3.TimelineEntryType.STOP_SESSION:
      return Icons_exports.StopSession;
    case import_firebase3.TimelineEntryType.ORGAN_ACCEPTED:
      return Icons_exports.OrganAccepted;
    case import_firebase3.TimelineEntryType.ORGAN_DECLINED:
      return Icons_exports.OrganDeclined;
    case import_firebase3.TimelineEntryType.TIME_OF_WITHDRAWAL:
      return Icons_exports.TimeOfWithdrawal;
    case import_firebase3.TimelineEntryType.WARM_ISCHEMIC_TIME_START:
      return Icons_exports.WarmIschemicTimeStart;
    case import_firebase3.TimelineEntryType.OBSERVATION_PERIOD_START:
      return Icons_exports.ObservationPeriodStart;
    case import_firebase3.TimelineEntryType.TIME_OF_DEATH:
      return Icons_exports.TimeOfDeath;
    case import_firebase3.TimelineEntryType.ORGAN_REMOVAL_LUNG:
      return Icons_exports.OrganRemovalLung;
    case import_firebase3.TimelineEntryType.ORGAN_REMOVAL_LIVER:
      return Icons_exports.OrganRemovalLiver;
    case import_firebase3.TimelineEntryType.HEART_REMOVED_FROM_SHERPAPAK:
      return Icons_exports.HeartRemovedFromSherpapak;
    case import_firebase3.TimelineEntryType.HEART_PLACED_IN_SHERPAPAK:
      return Icons_exports.HeartRemovedFromSherpapak;
    case import_firebase3.TimelineEntryType.LIVER_REMOVED_FROM_LIVERGUARD:
      return Icons_exports.LiverRemovedFromLiverguard;
    case import_firebase3.TimelineEntryType.LIVER_PLACED_IN_LIVERGUARD:
      return Icons_exports.LiverRemovedFromLiverguard;
    case import_firebase3.TimelineEntryType.LUNGS_REMOVED_FROM_LUNGGUARD:
      return Icons_exports.LungsRemovedFromLungguard;
    case import_firebase3.TimelineEntryType.LUNG_PLACED_IN_LUNGGUARD:
      return Icons_exports.LungsRemovedFromLungguard;
    case import_firebase3.TimelineEntryType.LEFT_LUNG_REMOVED_FROM_LUNGGUARD:
      return Icons_exports.LeftLungRemovedFromLungguard;
    case import_firebase3.TimelineEntryType.RIGHT_LUNG_REMOVED_FROM_LUNGGUARD:
      return Icons_exports.RightLungRemovedFromLungguard;
    case import_firebase3.TimelineEntryType.LEFT_LUNG_ANASTOMOSIS_COMPLETE:
      return Icons_exports.LeftLungAnastomosisComplete;
    case import_firebase3.TimelineEntryType.RIGHT_LUNG_ANASTOMOSIS_COMPLETE:
      return Icons_exports.RightLungAnastomosisComplete;
    case import_firebase3.TimelineEntryType.PORTAL_REPERFUSION:
      return Icons_exports.PortalReperfusion;
    case import_firebase3.TimelineEntryType.ARTERIAL_REPERFUSION:
      return Icons_exports.ArterialReperfusion;
    case import_firebase3.TimelineEntryType.PERFUSION_START:
      return Icons_exports.PerfusionStart;
    case import_firebase3.TimelineEntryType.PERFUSION_STOP:
      return Icons_exports.PerfusionStop;
    case import_firebase3.TimelineEntryType.RECIPIENT_LEFT_LUNG_OFF_CLAMP:
      return Icons_exports.CrossclampAtDonor;
    case import_firebase3.TimelineEntryType.RECIPIENT_RIGHT_LUNG_OFF_CLAMP:
      return Icons_exports.CrossclampAtDonor;
    case import_firebase3.TimelineEntryType.ON_CARDIO_PULMONARY_BYPASS_1:
      return Icons_exports.OnCardioPulmonaryBypass;
    case import_firebase3.TimelineEntryType.ON_CARDIO_PULMONARY_BYPASS_2:
      return Icons_exports.OnCardioPulmonaryBypass;
    case import_firebase3.TimelineEntryType.OFF_CARDIO_PULMONARY_BYPASS_1:
      return Icons_exports.OffCardioPulmonaryBypass;
    case import_firebase3.TimelineEntryType.OFF_CARDIO_PULMONARY_BYPASS_2:
      return Icons_exports.OffCardioPulmonaryBypass;
    case import_firebase3.TimelineEntryType.START_WEAN_1:
      return Icons_exports.StartWean;
    case import_firebase3.TimelineEntryType.START_WEAN_2:
      return Icons_exports.StartWean;
    case import_firebase3.TimelineEntryType.ANASTOMOSIS:
      return Icons_exports.Anastomosis;
    case import_firebase3.TimelineEntryType.ORGAN_REMOVAL_PANCREAS:
      return Icons_exports.OrganRemovalPancreas;
    case import_firebase3.TimelineEntryType.PANCREAS_PLACED_IN_PANCREASPAK:
      return Icons_exports.PancreasPlacedInPancreaspak;
    case import_firebase3.TimelineEntryType.PANCREAS_REMOVED_FROM_PANCREASPAK:
      return Icons_exports.PancreasRemovedFromPancreaspak;
    case import_firebase3.TimelineEntryType.HEAD_VESSEL_CLAMP:
      return Icons_exports.HeadVesselClamp;
    case import_firebase3.TimelineEntryType.COLD_PRESERVATION_FLUSH:
      return Icons_exports.ColdPreservationFlush;
    case import_firebase3.TimelineEntryType.CANNULATION:
      return Icons_exports.Cannulation;
    default:
      return Icons_exports.Help;
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AddressAutocomplete,
  COUNTRIES,
  CountrySelect,
  Icons,
  LoadGoogle,
  SessionTrackingMap,
  formatCountry,
  timelineEntryIcon
});
